import { API_ERROR_COPY, friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { Component, ElementRef, EventEmitter, HostListener, Injectable, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as d3 from "d3";
import * as htmlToImage from 'html-to-image';
import { LineChartComponent } from '../line-chart/line-chart.component';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute } from '@angular/router';
import { BarChartComponent } from '../bar-chart/bar-chart.component';
import { MatMenuPanel, MatMenuTrigger } from '@angular/material/menu';
import { DialogService } from 'src/app/services/dialog.service';
import { ExcelExportService } from 'src/app/services/excelExport.service';
import moment from 'moment';
import { FilterService } from 'src/app/services/filter.service';
import { fromEvent, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { GanttChartComponent } from '../gantt-chart/gantt-chart.component';
// import { CurrencyPipe } from '@angular/common';
import { NumberPipe } from 'src/app/pipe/number.pipe';
import { BubbleChartComponent } from '../bubble-chart/bubble-chart.component';
import { SparklinesGridComponent } from '../sparklines-Grid/sparklines-grid.component';
import { CsvExportService } from 'src/app/services/csvexport.service';
import { ChoroplethMapChartComponent } from '../choropleth-map-chart/choropleth-map-chart.component';
import { NetworkChartComponent } from '../network-chart/network-chart.component';
import { ComboBarChartComponent } from '../combo-bar-card/combo-bar-chart.component';
import { WordCloudChartComponent } from '../word-cloud-chart/word-cloud-chart.component';
import { GroupedHbarChartComponent } from '../grouped-hbar-chart/grouped-hbar-chart.component';
import { SmallBarChartComponent } from '../small-bar-chart/small-bar-chart.component';
import { AreaLineComboChartComponent } from '../area-line-combo-chart/area-line-combo-chart.component';
import { BulletChartComponent } from '../bullet-chart/bullet-chart.component';
import { HierarchicalGridChartComponent } from '../hierarchical-grid-chart/hierarchical-grid-chart.component';
import { SlopeChartSComponent } from '../slope-chart/slope-chart.component';
import { HbarChartComponent } from '../hbar-chart/hbar-chart.component';
import { CurrencyPipe } from '@angular/common';
import { BasicHeatmapComponent } from '../basic-heatmap/basic-heatmap-chart.component';
import { KpiBreakdownHeatmapComponent } from '../kpi-breakdown-heatmap/kpi-breakdown-heatmap-chart.component';
import { ScatterPlotChartComponent } from '../scatter-plot-chart/scatter-plot-chart.component';
import { PixelMapComponent } from '../pixel-map/pixel-map.component';
import { ChordChartComponent } from '../chord-chart/chord-chart.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopupStatusComponent } from '../../popup-status/popup-status.component';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { DeviceDetectionService } from 'src/app/services/detectipad.service';
import { UserActivityService } from 'src/app/services/useractivity.service';
import { ControlChartComponent } from '../control-chart/control-chart.component';
import { WidgetPivotGridComponent } from 'src/app/components/widget/pivot-Grid/pivot-grid.component';
import { StatusCodesComponent } from 'src/app/components/widget/status-codes/status-codes.component';
import { StackedAreabarComponent } from '../stacked-areabar/stacked-areabar.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CalculationService } from 'src/app/services/calculation.service';
import { ApiService } from 'src/app/services/api.service';
import { ExportPPTService } from 'src/app/services/export-ppt.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { horizontalHarChartComponent } from '../horizontal-bar-chart/horizontal-bar-chart.component';
// import htmlToPdfmake from 'html-to-pdfmake';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { EnhancementService } from 'src/app/services/enhancements-service';
import { AreaLineComboNewChartComponent } from '../area-line-combo-chart_new/area-line-combo-new-chart.component';
import { stackedComboBarChartComponent } from '../stacked-combo-bar-chart/stacked-combo-bar-chart.component';
import { HashtagService } from '../../comments-notes/hashtag.service';
(pdfMake as any).vfs = (pdfFonts as any).pdfMake?.vfs ?? (pdfFonts as any).default ?? (pdfFonts as any);
import { GridStateService } from 'src/app/services/grid-state.service';
import { HttpClient } from '@angular/common/http';
import html2canvas from 'html2canvas';
import { normaliseColorsForHtml2canvas } from '../html2canvas-colors';
import { PreferencesComponent } from '../../preferences/preferences.component';
import { LoginPopupComponent } from '../../login-popup/login-popup.component';
import { PhiTimerService } from 'src/app/services/phi-timer.service';
import { PhiSecurityService } from 'src/app/services/phi-security.service';
import { set } from 'lodash';
import * as CHART_PREFS from 'src/assets/json/ChartPrefrencesConfig.json';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { PageDataService } from 'src/app/services/page-data.service';
// import { ChartPreferencesFormlyComponent } from '../../chart-preferences-formly/chart-preferences-formly.component';
@Injectable({
  providedIn: 'root'
})

@Component({
    selector: 'icon-chart',
    templateUrl: './icon-chart.component.html',
    styleUrls: ['./icon-chart.component.scss'],
    standalone: false
})

export class IconChartComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild("prompt", { static: true }) prompt!: ElementRef;
  @ViewChild("controlPopup", { static: true }) controlPopup!: ElementRef;
  @ViewChild("pdfCustom", { static: true }) pdfCustom!: ElementRef;
  @ViewChild("ExportToTablePDF", { static: true }) ExportToTablePDF!: ElementRef;
  @ViewChild("menu") info!: MatMenuPanel;
  @ViewChild("Exportmenu") Exportmenu!: MatMenuPanel;
  @ViewChildren(MatMenuTrigger) menuTriggers!: QueryList<MatMenuTrigger>;
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  @ViewChild('progressBar') progressBar!: TemplateRef<any>;

  @Input('rowDataCount') rowDataCount: any;
  @Input('iconList') iconList: any;
  @Input('pageKey') pageKey: any;
  @Input('data') data: any;
  @Input('rowDataLength') rowDataLength: any;
  @Input('item') item: any;
  @Input('config') config: any;
  @Input('exportcolumnDefs') exportcolumnDefs: any;
  @Input('selectedTypeTimeCyle') selectedTypeTimeCyle: any;
  @Input('heading') heading: any;
  @Input('navHeading') navHeading: any;
  @Input('sliderValue') sliderValue: any;
  @Input('chartName') chartName: string = "";
  @Input('expand') expand: any;
  @Input('fullscreen') isFullscreen: any;
  @Input('widgetTitle') widgetTitle: any;
  @Input('headerConfig') headerConfig: any;
  @Input('alertIcons') alertIcons: any;
  @Input('selectedFilter') selectedFilter: any;
  @Input('sourceHeaderName') sourceHeaderName: any;
  @Input('apiKey') apiKey: any;
  @Input('excelConfig') excelConfig: any;
  @Input('paginationPageSize') paginationPageSize: any;
  @Input('chartType') chartType: any = 'parent';
  @Input('settings') settingsInput: any;
  @Input('maxValue') maxValue: number = 100;
  @Input() scatterPlotRef!: ScatterPlotChartComponent; // Receive reference
  @Input() pixelMapRef!: PixelMapComponent; // Receive reference
  @Input() chordChartRef!: ChordChartComponent; // Receive reference
  @Input('phiChecked') phiChecked: any;
  // @Input('captureStateViewInfo') captureStateViewInfo: any;
  watermarkMode: boolean = false; // Watermark mode toggle state

  @Input('selectedPointsLength') selectedPointsLength: any; // Receives data from scatter_plot
  // @Input('colorTypes') colorTypes:any; // Receives data from scatter_plot
  @Input('hasPhiHiddenToggle') hasPhiHiddenToggle = false; // Receives data from scatter_plot
  @Input('networkExcelDropdownData') networkExcelDropdownData: any; // Receives data from scatter_plot
  @Input('mapDesignerConfig') mapDesignerConfig: any; // Receives data from territory_map
  @Input('selectedMapShowBy') selectedMapShowBy: any; // Receives data from territory_map
  @Input('selectedMapConfig') selectedMapConfig: any; // Receives data from territory_map

  // @ViewChild('prefForm') prefFormComponent!: ChartPreferencesFormlyComponent;

  @Input("selectedHeader") selectedHeader: any;
  @Input('showErrorColumns') showErrorColumns: boolean = false;
  @Input('showFailColumns') showFailColumns: boolean = false;
  // Open error / fail totals shown on the ERROR and FAIL legend chips. null (the
  // default) leaves the chips label-only, as they were.
  @Input('errorCount') errorCount: number | null = null;
  @Input('failCount') failCount: number | null = null;
  /**
   * This widget's help text, supplied by the host instead of fetched — an
   * { info_header, info_text } pair, the same shape getInfoDetail() puts on
   * `infoData`, so the header's existing Help icon and #info popover render it
   * with no other change.
   *
   * For hosts that already hold their help text and have no key the API could
   * answer by: the static dashboards ship theirs as an asset
   * (assets/help_info/*.json) rather than owning a page_key / widget_key row.
   *
   * Opt-in and additive — left undefined, the Help icon fetches exactly as before,
   * which is every other caller.
   */
  @Input('staticInfo') staticInfo: any;
  @ViewChild('preferenceTemplate') preferenceTemplate!: any;
  @ViewChild('settingsTrigger') settingsTrigger!: ElementRef;
  private overlayRef: OverlayRef | null = null;
  private resizeObserver!: ResizeObserver;
  @Output() expendCol = new EventEmitter();
  isOpen = false;

  overlayPositions: any = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom'
    }
  ];

  // Login popup control
  showLoginPopup: boolean = false;
  setting = "setting-sm"
  counter: any = 2;
  plus = "plus_icons"
  minus = "frame 4"
  sliderArray: any = []
  iconList1: any = [];
  gridsize: any = 30;
  cardName: any;
  cardId: any;
  clicked: Boolean = false
  clientKey: any; thresholdoldData: any
  dialogRef!: MatDialogRef<any>;

  sortByArray: any = [];
  Buffer: boolean = false
  isPortraitMode: boolean = false
  iconsWithoutPopup: boolean = false;
  minValue = 1;
  // maxValue = 100;
  showByvalue = 'sp'
  inputPagenationFromDir = true;
  userForm!: FormGroup;
  Previews: boolean = false
  look_back_period: any = 0
  no_of_std_deviations: any = 0
  upper_threshold: any = 0
  lower_threshold: any = 0
  buffer_range: any = 0
  selectedCount: any = 2
  reqSubcription: Subscription[] = [];
  private phiTimerSubscription: Subscription | null = null;
  moment = moment
  detailData: any = [];
  clickedevent: boolean = false
  nav_header_name: any = ''
  dashboardKey: any;
  showSettings: boolean = false;
  preference: any
  showTotalTriaged: boolean = true;

  @Output() serverSideSearchEmits = new EventEmitter();
  @Output() typeToSearch = new EventEmitter();
  @Output() onPageSizeChange = new EventEmitter();
  @Output() phiFromGrid = new EventEmitter();
  @Output() exportXls = new EventEmitter();
  @Output() screenChanges = new EventEmitter();
  @Output() timeCycleChanges = new EventEmitter();
  @Output() sliderValueEmitter = new EventEmitter();
  @Output() compareMaxNumber = new EventEmitter();
  @Output() preferenceEmitter = new EventEmitter();
  @Output() exportToPdf = new EventEmitter();
  @Output() chartTypeEmitter = new EventEmitter();
  @Output() changeDisplays = new EventEmitter();
  @Output() layerControl = new EventEmitter();
  @Output() showbyChanges = new EventEmitter();

  @Output() showBySubs = new EventEmitter();
  @Output() showByMapSubs = new EventEmitter();
  @Output() hoverValueChange = new EventEmitter<number>();
  @Output() togglePracticeType = new EventEmitter();
  @Output() toggleErrorColumns = new EventEmitter<void>();
  @Output() toggleFailColumns = new EventEmitter<void>();

  selectedValue: any;
  isActive = false;
  pagination: boolean = false;
  pivot: boolean = true;
  NetworkChartData: any = [];
  dateFormat: boolean = true;

  infoData: any;
  gridData: any = [];
  columnDefs: any = [];
  expandChart: boolean = false;
  PdfPosition: any = 'l';
  choroDeta: any;
  sourceName: any;
  SettingValue: any;
  compareChart: boolean = false;
  Stddeviation: boolean = true;
  Thresholdsvalues: boolean = true;
  SubHeading: any = '';
  MeanAvg: boolean = false;
  expandCollapseIcon = "gridload_circle";
  expandOrCollapse = "Expand All";
  selectedType: string = "percent";
  annotations: boolean = false;
  settingpopup: Boolean = false;
  progress = 0;
  progressInterval: any;
  /** Verb shown in the progress dialog — "Exporting" (Export as Image) or "Copying" (clipboard). */
  progressLabel = 'Exporting';
  isprogress = false
  /** When the PNG export fails, the dialog flips into an error state instead
   *  of auto-closing — exportError = true shows the error message + close icon. */
  exportError = false;
  exportErrorMessage: string = API_ERROR_COPY.unknown;
  moduleName:any;

  isPopoverOpen: boolean = false;

  ispreferencesOpen: boolean = false;

  settingsm = "setting-sm"
  isButtonClicked = false;
  historyFlag: any;
  searchByKey: any = [];
  userStateForServerSideSearch = "";
  searchBySelectedName: any;
  @Input('selectedSearchByKey') selectedSearchByKey: any = 'All';
  @Input('serverSideSearchFilterText') serverSideSearchFilterText: any;
  @Input('clientSideSearchFilterText') clientSideSearchFilterText: any;
  patientId: any;
  @Input('hashtagInList') hashtagInList = false;
  widgetUniqKey: any;
  phiSearchInfo: any;
  chartPrefConfig: any;
  isApplyClicked: boolean = false;

  onWindowResize(event: any) {
    this.checkOrientation();
  }

  checkOrientation() {
    this.isPortraitMode = window.innerHeight > window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isPortraitMode = window.innerHeight > window.innerWidth;
  }

  chartBack($event: any) {
    this.chartTypeEmitter.emit(true);
  }

  isFlexWrapped = false;

  // True when the header text is cut off by the ellipsis, so the full-name tooltip only shows then
  isTextClipped(element: HTMLElement): boolean {
    return !!element && element.scrollWidth > element.clientWidth + 1;
  }

  onWrapChange(event: { wrapped: boolean, startIndex?: number }) {
    this.isFlexWrapped = event?.wrapped ?? false;
    if (this.headerConfig?.length <= 2) return;

    const selectedIndex = this.headerConfig.findIndex((item: any) => item.icon_selected);

    // Do nothing if no selected item found
    if (selectedIndex === -1) return;
    if (event?.wrapped && event.startIndex && event.startIndex <= 1) return;

    const [selectedItem] = this.headerConfig.splice(selectedIndex, 1); // remove the selected item

    if (event?.wrapped && typeof event.startIndex === 'number') {
      const startIndex = event.startIndex;

      // Insert before wrap startIndex, adjust for array shift if needed
      const insertIndex = startIndex - 1;
      this.headerConfig.splice(insertIndex, 0, selectedItem);
    } else {
      // Move selected item to the end
      this.headerConfig.push(selectedItem);
    }
  }

  findSearchBySelectedName(key: any, hdr?: any) {
    if (this.filterService.phiChecked) {
      if (!this.searchByKey.some((o: any) => o.value === 'PH')) {
        this.searchByKey.push(this.phiSearchInfo);
      }
    } else {
      this.searchByKey = this.searchByKey.filter((o: any) => o.value !== 'PH');
    }

    this.searchBySelectedName = this.searchByKey.find((f: any) => f.value == key);
  }

  constructor(private LineChart: LineChartComponent, private currency: CurrencyPipe,
    private GanttChart: GanttChartComponent,
    private BarChart: BarChartComponent,
    private bubbleChart: BubbleChartComponent,
    private SparklinesGrid: SparklinesGridComponent,
    private comboBar: ComboBarChartComponent,
    private stackedComboBar: stackedComboBarChartComponent,
    private dataService: DataService,
    private router: ActivatedRoute,
    private dialogService: DialogService,
    private excelService: ExcelExportService,
    public numberPipe: NumberPipe,
    public filterService: FilterService,
    private Csvexport: CsvExportService,
    private ChoroplethChart: ChoroplethMapChartComponent,
    private NetworkChart: NetworkChartComponent,
    private wordColud: horizontalHarChartComponent,
    private GroupedHbar: GroupedHbarChartComponent,
    private smallBar: SmallBarChartComponent,
    private areaLine: AreaLineComboNewChartComponent,
    private bulletChart: BulletChartComponent,
    private paymentGrid: HierarchicalGridChartComponent,
    private slopeChart: SlopeChartSComponent,
    private HBarChart: HbarChartComponent,
    private basicHeatMap: BasicHeatmapComponent,
    private KpiHeatMap: KpiBreakdownHeatmapComponent,
    private userActivityService: UserActivityService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public newFilterService: NewFilterService,
    public deviceDetectionService: DeviceDetectionService,
    private controlChart: ControlChartComponent,
    public pivotGrid: WidgetPivotGridComponent,
    public statusCodeRef: StatusCodesComponent,
    private StackAreaBar: StackedAreabarComponent, private fb: FormBuilder, public calculationStd: CalculationService,
    private navigationService: NavigationService,
    public enhancementService: EnhancementService,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private hashtagService: HashtagService,
    private overlay: Overlay,
    private vcr: ViewContainerRef,
    private phiTimerService: PhiTimerService,
    private phiSecurityService: PhiSecurityService,
    private mixpanelService: MixpanelService,
    public dashboardService: DashboardService,
    public pageDataService: PageDataService
  ) {

    this.filterService.expendTree.subscribe((r: any) => {
      if (r.key == this.item.config.widgetKey) { this.expandChart = r.value }
    })

    this.filterService.settingpopupclose.subscribe((res: any) => {
      this.settingpopup = false
    })

    // Want to set the settings menu to default values on load
    // this.filterService.filterQuery.subscribe((res: any) => {
    //   if(document.getElementById("setting")){
    //     this.reset(false);
    //   }
    // })

    this.filterService.inputValueOfPagenation.subscribe((re: any) => {
      this.inputPagenationFromDir = re
    })
    this.filterService.filterQuery.subscribe((query: any) => {
      this.compareChart = false;
      this.expandChart = false;
      // this.cardName = this.route.snapshot.params['cardName'] || sessionStorage.getItem('recdetailGrid')
    });

    this.route.params.subscribe((p: any) => {
      this.sourceName = p["cardName"];
      this.cardName = p["cardName"];

      this.moduleName = p['module'] || '';

      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];

        this.clientKey = decryptedParams["cl_key"];
        this.cardId = decryptedParams["cardId"] || '';
        this.dashboardKey = decryptedParams["ds_key"] || '';
        this.patientId = decryptedParams["cardId"];
        this.historyFlag = decryptedParams["hist_flg"] || undefined;

        // Payment Calc Record Level Header
        if (params?.['record'] == 'yes' && sessionStorage.getItem("filterData")) {
          let filter: any = sessionStorage.getItem("filterData")
          const queryFilterData = JSON.parse(filter) || {};
          if (queryFilterData instanceof Array && queryFilterData?.length) {
            this.detailData = queryFilterData;
            const lastElement = this.detailData.pop();
            this.detailData.unshift(lastElement);
          } else {
            this.detailData = [];
          }
        }
      });

    });

    this.reqSubcription.push(this.filterService.kpiBreakDownSelectedType.subscribe((p: any) => {
      this.compareChart = false
    }))
  }

  openDialogIcon() {
    this.dialogRef = this.dialog.open(this.dialogTemplate, {
      width: '280px',
    });

    this.dialogRef.afterClosed().subscribe(() => {
      // Handle the result here if needed
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  selectedVal() {
    this.counter = this.selectedCount
  }
  PopoverOpen() {
    // setTimeout(() => {
    this.isPopoverOpen = !this.isPopoverOpen;
    if (this.chartName != "PixelMapDiv") {
      if (this.isPopoverOpen) { this.reset(false) }
    }
    // },0)
  }
  isPrefOpen() {
    this.ispreferencesOpen = !this.ispreferencesOpen;
    // console.log(this.preference,'open');
  }

  cancel() {
    // document.getElementById("setting")?.click()
    this.isPopoverOpen = false;
    this.reset()
  }

  movingavgs() {
    this.counter = this.selectedCount
    document.getElementById("moving_average")?.click()
  }

  allSelected = false;
  dimensions: any[] = [];
  private backupDimensions: any;
  totalPercentageConstant: any = true;

  // Called when menu opens - backup current state
  onMenuOpen() {
    this.backupDimensions = {
      dimensions: JSON.parse(JSON.stringify(this.dimensions)),
      showTotalTriaged: this.showTotalTriaged
    };
  }

  // Restore previous state if menu closed without apply
  onMenuClose() {
    if (!this.backupDimensions) return;

    this.dimensions = JSON.parse(JSON.stringify(this.backupDimensions.dimensions));
    this.showTotalTriaged = this.backupDimensions.showTotalTriaged;

    this.onChange();
  }

  // Toggle all checkboxes
  toggleAll(checked: boolean) {
    this.dimensions.forEach((d: any) => d.selected = checked);
    this.onChange();
  }

  // Check if all selected
  isAllSelected(): boolean {
    return this.dimensions.length > 0 && this.dimensions.every((d: any) => d.selected);
  }

  // On checkbox change
  onChange() {
    this.allSelected = this.isAllSelected();
  }
  toggleTriaged(event: any) {
    //  event.stopPropagation();
    this.showTotalTriaged = event.checked;
  }

  // Apply selected values
  applySelection() {
    const selected = this.dimensions.filter((d: any) => d.selected);

    this.layerControl.emit({
      selected,
      showTotalTriaged: this.showTotalTriaged
    });

    // Overwrite backup after apply
    this.backupDimensions = {
      dimensions: JSON.parse(JSON.stringify(this.dimensions)),
      showTotalTriaged: this.showTotalTriaged
    };

    this.isApplyClicked = true;   // so dimensionsData won't restore backup on next click
  }

  // Disable apply button if less than 2 items selected
  get isApplyDisabled(): boolean {
    const selectedCount = this.dimensions.filter((d: any) => d.selected).length;
    return selectedCount < 2;
  }

  // Clear all selections
  clearSelection() {
    this.dimensions.forEach((d: any) => d.selected = false);
    this.onChange();
  }

  // Set dimensions data on icon click
  dimensionsData(hdr: any, icon: any) {
    if (!hdr.add_toggle) return;
    this.totalPercentageConstant = hdr?.total_percentage_constant ?? true;

    // always get layer data from header
    const layerData = JSON.parse(JSON.stringify(hdr.layer_name || []));

    // --------------------------------------
    // CASE 1: FIRST OPEN → SET BACKUP ONCE
    // --------------------------------------
    if (!this.backupDimensions) {
      this.backupDimensions = {
        dimensions: JSON.parse(JSON.stringify(layerData)),
        showTotalTriaged: this.showTotalTriaged
      };

      // Current copy
      this.dimensions = JSON.parse(JSON.stringify(this.backupDimensions.dimensions));
      this.isApplyClicked = false;
      this.onChange();
      return;
    }

    // --------------------------------------
    // CASE 2: CANCEL OR REOPEN WITHOUT APPLY
    // restore old backup
    // --------------------------------------
    if (!this.isApplyClicked) {
      this.dimensions = JSON.parse(JSON.stringify(this.backupDimensions.dimensions));
      this.showTotalTriaged = this.backupDimensions.showTotalTriaged;

      this.onChange();
      return;
    }

    // --------------------------------------
    // CASE 3: REOPEN AFTER APPLY
    // update backup from CURRENT APPLIED VALUES
    // DO NOT USE layerData HERE ❌
    // --------------------------------------
    this.backupDimensions = {
      dimensions: JSON.parse(JSON.stringify(this.dimensions)), // applied values
      showTotalTriaged: this.showTotalTriaged
    };

    // reload applied values into popup UI
    this.dimensions = JSON.parse(JSON.stringify(this.backupDimensions.dimensions));
    this.onChange();
  }

  annotationmethod() {
    this.annotations = !this.annotations
    this.filterService.annotations = this.annotations
    this.controlChart.props.showDragSelect = !this.annotations
    this.controlChart.getControlChartData()
    d3.select("#d3pincontrolChartTooltip")
      .style('visibility', 'hidden')
    d3.select("#d3controlChartTooltip")
      .style('visibility', 'hidden');
    d3.select("#d3annotationsTooltip")
      .style('visibility', 'hidden');
  }

  // --- Control chart settings (shuffle icon) selection helpers -------------------------------
  // The popup has to read/write the properties row of the SELECTED series only. The properties
  // list can hold a row per source/kpi, so index 0 is not necessarily the selection.

  // Field names that identify one series in both the chart data and the properties rows,
  // driven by config (chart_data = "kpi_key,source_key").
  private getSeriesKeyVars(): string[] {
    const chartData = this.item?.config?.['chart_data']
    const keyVars = typeof chartData == 'string'
      ? chartData.split(',').map((v: string) => v.trim()).filter((v: string) => v)
      : []
    return keyVars.length ? keyVars : ['kpi_key', 'source_key']
  }

  // Data row of the selected series — the tile the chart was opened for. null when the chart
  // holds more than one series (multi selection), where narrowing to one row would be wrong.
  private getSelectedSeries(): any {
    const data: any[] = this.controlChart?.ControlChartData?.['data'] || []
    if (!data.length) return null
    const keyVars = this.getSeriesKeyVars()
    const distinct = new Set(data.map((d: any) => keyVars.map((v: string) => d[v]).join('|')))
    return distinct.size == 1 ? data[0] : null
  }

  // A properties row can carry the identifier under its dim-key name instead of the data-row name.
  private readonly seriesKeyAliases: any = {
    source_key: ['source_key', 'data_source_dim_key', 'data_source_key'],
    kpi_key: ['kpi_key', 'kpi_dim_key']
  }

  // Does this properties row belong to the given series (data) row?
  private matchesSelectedSeries(property: any, row: any): boolean {
    if (!property || !row) return false
    return this.getSeriesKeyVars().every((keyVar: string) => {
      const field = (this.seriesKeyAliases[keyVar] || [keyVar]).find((f: string) => property[f] != null)
      return field != null && row[keyVar] != null && String(property[field]) === String(row[keyVar])
    })
  }

  // Index of the properties row belonging to the selected series; 0 when there is no match.
  private getSelectedPropertyIndex(row: any = this.getSelectedSeries()): number {
    const properties: any[] = this.controlChart?.ControlChartData?.['properties'] || []
    if (!row || !properties.length) return 0
    const index = properties.findIndex((p: any) => this.matchesSelectedSeries(p, row))
    return index > -1 ? index : 0
  }

  // Keeps only the properties rows of the selected series, so the settings values shown and the
  // limits recalculated belong to that tile. Untouched for multi selections / when nothing matches.
  private scopePropertiesToSelection(properties: any[]): any[] {
    const row = this.getSelectedSeries()
    if (!row || !properties?.length) return properties || []
    const scoped = properties.filter((p: any) => this.matchesSelectedSeries(p, row))
    return scoped.length ? scoped : properties
  }
  // -------------------------------------------------------------------------------------------

  // checkedPreview = false;
  preview() {
    if (this.upper_threshold < this.lower_threshold) {
      this.upper_threshold = 0
      this.lower_threshold = 0
      alert("lower Threshold should not be greater than upper Threshold")
      return
    }
    // if(this.upper_threshold>this.lower_threshold){
    //   this.upper_threshold=0
    //   this.lower_threshold=0
    //   alert("upper Threshold should not be less than  lower  Threshold")
    //   return
    // }
    this.controlChart.props.showMeanLine = this.MeanAvg
    // preview the values against the selected series' properties row, not blindly the first one
    const selectedProps: any = this.controlChart.ControlChartData['properties']?.[this.getSelectedPropertyIndex()]
    if (!selectedProps) return
    if (this.Stddeviation) {
      selectedProps['look_back_period'] = this.look_back_period || 0
      selectedProps['no_of_std_deviations'] = this.no_of_std_deviations || 0
    } else {
      selectedProps['look_back_period'] = null
      selectedProps['no_of_std_deviations'] = null
    }
    if (this.Thresholdsvalues) {
      selectedProps['lower_threshold'] = this.lower_threshold == 0 ? 0 : this.lower_threshold || null
      selectedProps['upper_threshold'] = this.upper_threshold || null
    }
    else {
      selectedProps['lower_threshold'] = null
      selectedProps['upper_threshold'] = null
    }
    if (this.Buffer) {
      selectedProps['buffer_range'] = (this.buffer_range / 100) || null
    } else {
      selectedProps['buffer_range'] = null
    }
    // this.controlChart.ControlChartData['properties'].forEach((element:any) => {
    //   if(this.Stddeviation==false && this.Thresholdsvalues==false && this.Buffer==false){
    //     return element["showCalculations"]= "false"
    //   }else if(this.Stddeviation==false){
    //     return element["showCalculations"]= "false"
    //   }else{
    //   return element["showCalculations"]= "true"}

    //  });
    this.calculationStd.calculationControlChart(this.controlChart.ControlChartData['data'], selectedProps)
    this.controlChart.plotChart()
  }

  updateSetting(event: any) {
    this.gridsize = event.value;

    this.filterService.sliderValue = this.gridsize

    this.filterService.refreshAlertDelete.next(this.gridsize)
    this.sliderValueEmitter.emit(event.value)
  }

  changeStatus() {
    if (!this.isButtonClicked) {
      this.isButtonClicked = true;
      this.dialog.open(PopupStatusComponent, {
        disableClose: true,
        width: '400px',
        height: '75',
        data: { endpoint: this.item?.config?.widget_endpoint || 'pss/get-pss-data' }
      });

      // this.filterService.baseQuery = this.newFilterService.getPatientStatusBaseQuery()
      // // patient status and patient reason we need to know, when navigate to Patient Card
      // const obj = {
      //   api_key: 6001,
      //   report_typ: "D",
      //   patient_id: this.cardId,
      //   client_key: this.clientKey || "",
      // }

      // this.reqSubcription.push(this.filterService.executePatientQuery(obj).subscribe((res: any) => {
      //   let response: any = res ? res : []
      //   let findPatient = response.find((fnd: any) => fnd.patient_id == this.cardId)

      //   let resData = {
      //     api_key: 100202,
      //     patient_status: null,
      //     report_typ: "D",
      //     patient_case_status: findPatient.case_status,
      //     patient_reason_status: findPatient.status_reason,
      //     patient_id: findPatient.patient_id
      //   }

      //   // debugger

      //   if ('pwt' == this.cardName.toLowerCase() || 'patient card' == this.cardName.toLowerCase() || 'card' == this.cardName.toLowerCase()) {

      //     // this.newFilterService.sendData(resData);

      //   }
      // }))

      setTimeout(() => {
        this.isButtonClicked = false;
      }, 2000);
    }
  }

  setSettingsPopup() {
    this.settingpopup = !this.settingpopup;
  }

  reset(plotChart = true) {
    this.settingpopup = true;
    if (!this.controlChart.props) {
      this.controlChart.props = {};
    }
    const propsApiKey = this.item?.config["list_of_prop_api"]?.api_key || 'no props apikey';
    this.controlChart.props.showMeanLine = false
    if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      this.reqSubcription.push(
        // selectedScope carries the selected tile (source / file type / cycle) when the chart runs
        // inside the control-chart popup — baseQuery alone would return every source's properties
        this.filterService.kpiBreakdownexecuteQuery(propsApiKey, this.controlChart?.selectedScope).subscribe((res: any) => {
          this.filterService.thresholdoldData = this.scopePropertiesToSelection(res == null ? [] : res);
          this.controlChart.ControlChartData['properties'] = this.filterService.thresholdoldData;
          this.controlChart.parentData = this.filterService.thresholdoldData;
          this.controlChart.ControlChartData['properties'].forEach((element: any) => {
            return element["showCalculations"] = "true";
          });
          this.calculationStd.calculationControlChart(this.controlChart.ControlChartData['data'], this.controlChart.ControlChartData['properties'][this.getSelectedPropertyIndex()]);
          if (plotChart) this.controlChart.plotChart();
          this.onSubmit();
        }, (error: any) => {
          // alert("can't able to reset , data not found , refresh the screen")
        })
      )
    }

  }

  Apply() {
    if (this.chartName == "PixelMapDiv") {
      console.log("hi dad");
      console.log(this.settingsInput);

      // update pixel map based on values set in settings popup.
      this.pixelMapRef.renderMain();
    }
    else {
      if (this.upper_threshold < this.lower_threshold) {
        this.upper_threshold = 0
        this.lower_threshold = 0
        alert("lower Threshold should not be greater than upper Threshold")
        return
      }
      // if(this.upper_threshold>this.lower_threshold){
      //   this.upper_threshold=0
      //   this.lower_threshold=0
      //   alert("upper Threshold should not be less than  lower  Threshold")
      //   return
      // }
      if (this.Stddeviation == false && this.Thresholdsvalues == false && this.Buffer == false) return

      // save against the SELECTED series only — its own data row and its own properties row
      const selectedRow: any = this.getSelectedSeries() || this.controlChart.ControlChartData['data']?.[0]
      const selectedProps: any = this.controlChart.ControlChartData['properties']?.[this.getSelectedPropertyIndex(selectedRow)]
      if (!selectedRow || !selectedProps) return

      // Save through the same properties api the settings popup reads with, and carry the same
      // selected-tile values (source / file type / cycle / day) as its payload — baseQuery alone
      // covers every source, so without selectedScope the write is not tied to this selection.
      const propsApiKey = this.item?.config["list_of_prop_api"]?.api_key || '999998'

      let postData: any = {
        ...(this.controlChart?.selectedScope || {}),
        "data_source_dim_key": selectedRow.source_key,
        "kpi_dim_key": selectedRow.kpi_key,
        "lower_threshold": this.lower_threshold,
        "upper_threshold": this.upper_threshold,
        "look_back_period": this.look_back_period,
        "no_of_std_deviations": this.no_of_std_deviations,
        "buffer_range": this.buffer_range,
        "kpi_properties_key": selectedProps.kpi_properties_key,
        "api_key": propsApiKey
      }

      this.reqSubcription.push(this.filterService.thresholdsexecuteQuery(postData).subscribe(
        (res: any) => {
          // this.filterService.thresholdoldData = res == null ? [] : res;
          // this.controlChart.ControlChartData['properties']=this.filterService.thresholdoldData
          // this.controlChart.plotChart()
          // this.onSubmit()
          this.reset(true)
        },
        // (error: any) => {
        //   alert("Error")
        // }
      ))
      // document.getElementById("setting")?.click()
      // this.settingpopup = false
      this.isPopoverOpen = false;
    }
  }

  onSubmit() {
    // this.reset()
    // this.settingpopup = true
    this.Stddeviation = true
    this.Thresholdsvalues = true
    this.Buffer = true
    this.MeanAvg = false
    // populate the inputs from the selected series' properties row
    let threshold: any = this.controlChart.ControlChartData['properties']?.[this.getSelectedPropertyIndex()] || {}
    this.look_back_period = threshold["look_back_period"] || this.look_back_period || null
    this.no_of_std_deviations = threshold["no_of_std_deviations"] || this.no_of_std_deviations || null
    this.buffer_range = (threshold["buffer_range"] > 1 && threshold["buffer_range"] < 101) ? threshold["buffer_range"] : threshold["buffer_range"] * 100 || null
    this.lower_threshold = threshold["lower_threshold"] || null
    this.upper_threshold = threshold["upper_threshold"] || null

  }

  ngOnInit(): void {
    this.sliderValue = this.filterService.sliderValue;
    this.headerConfig = this.headerConfig?.filter((flr: any) => flr.add_header == true)

    let fndData = this.headerConfig?.find((r: any) => r.add_header && r.value == 'search_box' && r.server_side_search_box);
    if (fndData?.searchByKey) {
      this.searchByKey = fndData?.searchByKey || [];
      this.selectedSearchByKey = this.searchByKey[0]?.value;
    } else {
      this.searchByKey = [];
    }

    this.reqSubcription.push(
      this.hashtagService.hashTagQuery.subscribe((res: any) => {
        if (this.hashtagInList) {
          this.serverSideSearchFilterText = res;
          this.selectedSearchByKey = "TAG";

          setTimeout(() => {
            this.serverSideSearch();
          }, 100);
        }
        this.clientSideSearchFilterText = res;
        this.typeToSearch.emit(this.clientSideSearchFilterText);
      })
    )

    // Subscribe to PHI timer expiration events
    // this.phiTimerSubscription = this.phiTimerService.onTimerExpired$.subscribe(
    //   () => {
    //     // Only show notification if PHI is currently enabled AND no notification is already showing
    //     if (
    //       this.phiChecked &&
    //       !this.phiTimerService.isNotificationDialogShowing()
    //     ) {
    //       // Mark that notification is being shown
    //       this.phiTimerService.setNotificationShowing(true);

    //       // Show notification dialog
    //       const dialogRef = this.dialog.open(LoginPopupComponent, {
    //         width: "450px",
    //         disableClose: true,
    //         data: {
    //           mode: "notification",
    //           message:
    //             "PHI access has expired for security. Please re-enable PHI columns by logging in again.",
    //         },
    //       });

    //       // After user acknowledges, disable PHI
    //       dialogRef.afterClosed().subscribe(() => {
    //         // this.phiChecked = false;
    //         this.watermarkMode = false; // Reset watermark mode state

    //         // Emit PHI state change to disable security restrictions
    //         this.filterService.isPHIFunc.next(this.phiChecked);
    //         this.phiFromGrid.emit(this.phiChecked);

    //         // Stop the timer (this also resets the notification flag)
    //         this.phiTimerService.stopTimer();
    //       });
    //     }
    //   },
    // );

    this.phiSearchInfo = this.searchByKey.find((o: any) => o.value === "PH");

    this.findSearchBySelectedName(this.selectedSearchByKey);

    this.checkOrientation();
    // this.timeCycleUserStatue();
    if (this.item?.config?.sortBy) {
      this.sortByArray = this.item.config?.sortBy?.controls
    }

    let headerName = this.headerConfig?.find((fnd: any) => fnd.value == "page_header")
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    
    const defaultSelectionToggle = this.headerConfig?.find((fnd: any) => fnd.value == "selection_toggle");
    this.selectedType = this.filterService.getSelectionToggle(widgetKey) ?? (defaultSelectionToggle?.toggle_btn?.[0]?.value);
    
    const pageChangeEntry = {selectedType: this.selectedType, findVar: defaultSelectionToggle?.groupby_page_level};
    this.filterService.pageChangeDisplaysAll.push(pageChangeEntry);
    const defaultPageChangeEntry = [...this.filterService.pageChangeDisplaysAll].reverse().find((o: any) => o.findVar && o.selectedType);
    this.filterService.pageChangeDisplays = defaultPageChangeEntry || pageChangeEntry;
    
    if(defaultSelectionToggle?.groupby_page_level) {
      this.filterService.chartshowBy.next({
        widget: this.item['key'],
        value: this.selectedType,
        item: this.item
      });
    }

    const defaultShowBy = this.headerConfig?.find((f: any) => f.value === 'show_by')?.show_by_value?.[0]?.value;
    
    this.showByvalue = this.filterService.getShowBySelection(widgetKey) ?? defaultShowBy;
    this.filterService.currentShowbySelection = this.showByvalue;
    this.heading = headerName ? headerName.page_header_name : "No Header"

    // nav header config
    if (headerName?.['nav_header']) {
      const value: any = this.filterService.navHeaderData ?? JSON.parse(sessionStorage.getItem("navHeaderData") || '{}');
      let arr = headerName.nav_header_var.split(",");
      arr.forEach((m: any) => {
        this.nav_header_name += " " + value[m];
      });
    }

    this.headerConfig?.find((i: any) => {
      if (i.value == 'icons') {
        this.iconsWithoutPopup = false
      } else {
        this.iconsWithoutPopup = true
      }
    })
    this.headerConfig?.forEach((res: any) => {
      if (res.slider) {
        this.sliderArray = []

        for (let i = res.sliderLenth[0].min || 1; i < res.sliderLenth[0].max || 7; i++) {
          this.sliderArray.push({ 'name': i, 'value': i })
          if (i == res.sliderLenth[0].max) break;
        }
      }
    })

    this.headerConfig?.find((i: any) => {
      if (i.value == 'icons') {
        i.iconList.forEach((j: any) => {
          if (j.activated) {
            this.iconList1.push(j)
          }
        })
      } else if (i.value == 'slider') {
        this.iconList1.push(i)
      }
    })
    this.iconList1?.find((i: any) => {
      if (i.name == 'dotmenu_circle') {
        i.event?.forEach((k: any) => {
          if (k.is_true) {
            this.iconList1.push(k)
          }
        })
      }
      if (i.name == 'compare') {
        i.event?.forEach((k: any) => {
          if (k.is_true) {
            this.compareMaxNumber.emit(k.maxNumber)
          }
        })
      }
    })
    const uniqueArrayOfObjects = [];
    const uniqueNames: any = [];
    for (const obj of this.iconList1) {
      if (!uniqueNames.includes(obj.name)) {
        uniqueNames.push(obj.name);
        uniqueArrayOfObjects.push(obj);
      }
    }

    this.iconList1 = uniqueArrayOfObjects
    const activityDaysIndex = this.iconList1.findIndex((obj: any) => obj.name === 'activity_days');
    if (activityDaysIndex > 0) {
      const activityDaysObj = this.iconList1.splice(activityDaysIndex, 1)[0];
      this.iconList1.unshift(activityDaysObj);
    }
    this.dataService.chartData.subscribe((resp: any) => {
      this.NetworkChartData = resp
    })
    this.dataService.choroplethData.subscribe((resp: any) => {
      this.choroDeta = resp
    })
    this.widgetUniqKey = widgetKey
    //chartPrefConfig
    this.chartPrefConfig = {
      dashboard_key: this.dashboardKey,
      page_name: this.item.config["report_heading"],
      page_key: this.pageKey,
      widget_uinique_key: this.widgetUniqKey,
      employee_key: this.filterService.baseQuery?.employee_key || 0,
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    // Get the modal element
    var modal = document.getElementById('exampleModal');

    // Remove the 'modal-backdrop' class
    modal?.classList.remove('modal-backdrop');

    // Remove the 'show' class
    modal?.classList.remove('show');

    // Attach the event listener to the window object
    window.addEventListener("resize", (event) => {
      // console.log('size changed')

    });
    if (changes['navHeading']?.currentValue != changes['navHeading']?.previousValue && this.navHeading) {
      this.nav_header_name = this.navHeading
    }
  }

  Compare() {
    // if we are comparing a KPIHeatMap
    if (this.KpiHeatMap.initiateChart) {
      // compare chart is false, do not show compare button
      // compare chart is true, show compare button
      this.compareChart = !this.compareChart;
      // Show selections if button is showing
      this.KpiHeatMap.props.showSelections = this.compareChart;
      this.KpiHeatMap.plotChart();
    }
    // comparing a Scatter Plot Chart
    else if (this.scatterPlotRef.initiateChart) {
      this.compareChart = !this.compareChart;
      // Show selections if button is showing
      this.scatterPlotRef.props.showSelections = this.compareChart;
    }
  }

  CompareBtn() {
    // if we are are comparing a KPIHeatMap
    if (this.KpiHeatMap.initiateChart) {
      this.KpiHeatMap.compareClick('route')
    }
    else if (this.scatterPlotRef.initiateChart) {
      this.scatterPlotRef.compareClick('route')
    }
  }

  SendtoHeatMap() {
    this.scatterPlotRef.showDataHeatMap();
  }

  manageStatus() {
    console.log("heehhehe");
    // 1. Ensure we are in analytical mode and the draft state is ready.
    this.setAnalyticalMode(true);
    this.pixelMapRef.openManageStatusesDialog();
  }

  getInfoDetail(icon?: any) {
    // A host that already holds this widget's help text short-circuits the fetch —
    // see staticInfo. No request is made at all: there is no page/widget key for the
    // API to answer by, so calling it would only come back "No Info Data Found" and
    // overwrite text we already have.
    if (this.staticInfo) {
      this.infoData = this.staticInfo;
      return;
    }
    let data: any = {
      api_key: this.item.config.list_of_api?.api_key || this.item.config.list_of_api || this.apiKey || 0,
      widget_key: this.item.config.widgetKey + (this.item?.config?.['info_key']||''),
      page_key: this.pageKey,
      report_typ: 'D',
      brand_key: this.filterService.baseQuery?.brand_key
    }
    if (this.chartName == "bubbleMapDiv") {
      data.api_key = 100115
    }
    if (this.chartName == "statusCodesUI") {
      data.api_key = 100180
    }
    if (this.chartName == "IRSummery") {
      data.api_key = 100134
    }
    if (this.chartName == "kpiBreakdownChartDiv") {
      data.api_key = 100203
    }
    if (this.chartName == "paymentSummary") {
      data.api_key = 100199
    }
    if (this.chartName == "GridListdetails") {
      data.api_key = 100250
    }
    // if (this.chartName == "") {
    //   data.api_key =
    // }if (this.chartName == "") {
    //   data.api_key =
    // }
    if (data.api_key == 0) { console.log('apiKey not found for info icon') }

    this.dataService.getInfoDetail(data).subscribe((res: any) => {
      this.infoData = res?.[0] || { info_header: "No Info Data Found", info_text: "No Info Text Available" };

      data["file_nm"] = icon?.info_fileName ? icon?.info_fileName : `PatientList_UserManual.pdf`;
      // Fetch the export URL for the user manual
      this.dataService.getExportUserManual(data).subscribe((url: any) => {
        if (url) {
          this.infoData["info_text"] = this.replacePlaceholder(this.infoData.info_text, url);
        } else {
          this.handleUserManualError(this.infoData);
        }
      },
        (err: any) => {
          if (err.status === 200) {
            this.infoData["info_text"] = this.replacePlaceholder(this.infoData.info_text, err.error.text);
          } else {
            this.handleUserManualError(this.infoData);
          }
        }
      );
    },
      (err) => {
        this.infoData = { info_header: "No Info Data Found", info_text: "Unable to fetch info text." };
      }
    );
  }

  private handleUserManualError(infoData: any): void {
    this.infoData["info_text"] = infoData.info_text.replace("??um_url", "??um_url");
  }

  // Helper function to replace placeholder
  private replacePlaceholder(text: string, url: string): string {
    return text.replace("??um_url", url);
  }

  closeMenu(cfg: any, event?: MouseEvent) {
    event?.stopPropagation()
    event?.stopImmediatePropagation()
    const openTrigger = this.menuTriggers?.find(t => t.menuOpen)
    openTrigger ? openTrigger.closeMenu() : cfg.close()
  }

  showByChange(values: any) {
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';

    // 🔑 Save to localStorage
    this.filterService.setShowBySelection(widgetKey, values);

    // Emit as before
    this.filterService.chartshowBy.next({
      widget: this.item['key'],
      value: values,
      item: this.item
    });

    this.filterService.currentShowbySelection = values;
    this.showBySubs.emit(values);
  }

  showByMapChange(values: any) {
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    // 🔑 Save to localStorage
    this.filterService.setShowByMapSelection(widgetKey, values);
    // Emit as before
    let emit = {
      widget: this.item['key'],
      value: values,
      item: this.item
    }
    this.showByMapSubs.emit(emit);
  }

  openPDF(imgData: any) {
    // Generate PDF

    var doc = new jsPDF(this.PdfPosition, 'pt', 'a4');
    if (this.PdfPosition == 'l') {
      doc.text(this.heading, 350, 30);
      doc.addImage(imgData, 'PNG', 0, 50, 830, 550);
    } else {
      doc.text(this.heading, 235, 30);
      doc.addImage(imgData, 'PNG', 0, 50, 600, 500);
    }

    doc.save(this.heading + '_export_' + moment(new Date()).format("DD-MMM-YYYY-hh.mma") + '.pdf');
  }

  onSaveChartClicked(pdfValue?: any): void {
    let value: any
    const theElement = this.config;
    // this.exportPPT.exportToPpt(theElement,this.heading)
    // return
    htmlToImage.toPng(theElement).then((dataUrl) => {
      this.openPDF(dataUrl);
      // value =dataUrl
      // const documentDefinition =  {
      //         content: [

      //           {
      //             style: "tableExample",
      //             table: {
      //               widths: ['*'],
      //               body: [
      //                 [

      //                   {
      //                     image:value,
      //                     fit: [500, 800]
      //                   }
      //                 ]
      //               ]
      //             }
      //           }
      //         ]
      //       };
      // pdfMake.createPdf(documentDefinition).open()
    });
  }

  openPDFcustom(PDFtype: any) {
    this.exportToPdf.emit(PDFtype);
    //  debugger
    // if ( PDFtype=='pdftable') {
    //   this.dialogService.openDialog(this.ExportToTablePDF, "80vw")
    //   return
    // }
    // if (this.chartName == 'PaymentGrid') {
    //   this.paymentGrid.openPDFcustom()
    // }
    // else {
    //   this.dialogService.openDialog(this.pdfCustom, '250')
    // }

  }

  openFullscreen(): void {
    const el = this.expand
    if (!document.fullscreenElement    // alternative standard method
    ) {  // current working methods
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.msRequestFullscreen) {

        el.msRequestFullscreen();
      }
    }

    // Ensure PHI security features remain active and visible in fullscreen mode
    // if (this.phiChecked && this.phiSecurityService.isRestrictionsEnabled()) {
    //   // The overlay needs to be moved to the element that just went fullscreen to be visible in the "Top Layer"
    //   this.phiSecurityService.showPHIWarningOverlay(el);
    // }

    setTimeout(() => {
      if (this.chartName == "lineChart") {
        this.LineChart.isFullscreen = true;
        this.LineChart.props.chartHeight = window.outerHeight - 60
      } else if (this.chartName == "barChart") {
        this.BarChart.props.chartHeight = window.outerHeight - 60
        this.BarChart.isFullscreen = true;
      } else if (this.chartName == "bubbleMapDiv") {
        // this.bubbleChart.props.chartHeight = window.outerHeight - 60
        this.bubbleChart.isFullscreen = true;
      }
      else if (this.chartName == "barGridDiv") {
        this.SparklinesGrid.isFullscreen = true;
        this.SparklinesGrid.gridHeight = window.outerHeight + "px"
      } else if (this.chartName == "GanttChart") {
        this.GanttChart.isFullscreen = true;
      } else if (this.chartName == "comboBar") {
        this.comboBar.props.chartHeight = window.outerHeight - 60
        this.comboBar.isFullscreen = true;
      } else if (this.chartName == "wordCloud") {
        // this.wordColud.props.fontSizeRange = [12, 40]
        this.wordColud.props.chartHeight = window.outerHeight - 60
        this.wordColud.isFullscreen = true;
      } else if (this.chartName == "GroupHBar") {
        this.GroupedHbar.props.chartHeight = window.outerHeight - 80
        this.GroupedHbar.isFullscreen = true;
      } else if (this.chartName == "smallBar") {
        this.smallBar.props.chartHeight = window.outerHeight - 60
        this.smallBar.isFullscreen = true;
      } else if (this.chartName == "BulletChartDiv") {
        this.bulletChart.props.chartHeight = window.outerHeight - 60
        this.bulletChart.isFullscreen = true;
      }
      else if (this.chartName == "areaLineChart") {
        this.areaLine.isFullscreen = true;
        this.areaLine.props.chartHeight = window.outerHeight - 70
      }
      // else if (this.chartName == "stackedComboBar") {
      //   this.stackedComboBar.isFullscreen = true;
      //   this.stackedComboBar.props.chartHeight = window.outerHeight - 70
      // }
      else if (this.chartName == "slopeChartDiv") {
        this.slopeChart.props.chartHeight = window.outerHeight - 60
        this.slopeChart.isFullscreen = true;
      } else if (this.chartName == "HBarChartDiv") {
        this.HBarChart.props.chartHeight = window.outerHeight - 60
        this.HBarChart.isFullscreen = true;
      } else if (this.chartName == "PaymentGrid") {
        this.paymentGrid.isFullscreen = true;
        this.paymentGrid.isActive = true
      } else if (this.chartName == "BasicHeatMapChartDiv") {
        this.basicHeatMap.isFullscreen = true;
        this.basicHeatMap.props.chartHeight = window.outerHeight - 60
      } else if (this.chartName == "kpiBreakdownChartDiv") {
        this.KpiHeatMap.isFullscreen = true;
        this.KpiHeatMap.props.chartHeight = window.outerHeight - 60
      } else if (this.chartName == "controlChartDiv") {
        this.controlChart.isFullscreen = true;
        this.controlChart.props.singleChartHeight = window.outerHeight - (this.controlChart.props.staticPlot ? 100 : 200)
      } else if (this.chartName == "StackAreaBar") {
        this.StackAreaBar.isFullscreen = true;
        this.StackAreaBar.props.chartHeight = window.outerHeight - 60
      } else if (this.chartName == "ChoroplethChart") {
        this.ChoroplethChart.isFullscreen = true;
      } else if (this.chartName == "NetworkChart") {
        this.isFullscreen = true;
        this.isActive = true
      } else if (this.chartName == "GridList") {
        this.isFullscreen = true;
        this.isActive = true
      } else if (this.chartName == "TerritoryDiv") {
        // this.TerritoryMap.isFullscreen = true;
        // this.TerritoryMap.isActive = true
      }
      else if (this.chartName == "scatterPlotChartDiv") {
        this.scatterPlotRef.isFullscreen = true;
        this.scatterPlotRef.props.chartHeight = window.outerHeight - 80;
        this.scatterPlotRef.cardWidthWithoutScrolling = window.outerWidth - 10;
        this.scatterPlotRef.width = window.outerWidth - 200;
        this.scatterPlotRef.plotChart(false);
      }
      else if (this.chartName == "PixelMapDiv") {
        this.isFullscreen = true;
        this.pixelMapRef.handleFullscreenChange();
      }
      // else if (this.chartName == "ChordChartDiv") { } 

      // ---------------------------//

      if (this.chartName == "lineChart") {
        this.LineChart.isActive = true;
        this.LineChart.plotChart()
      }
      else if (this.chartName == "barChart") {
        this.BarChart.isActive = true;
        this.BarChart.plotChart()
      }
      else if (this.chartName == "GanttChart") {
        this.GanttChart.isActive = true;
        // this.GanttChart.plotChart()
      }
      else if (this.chartName == "ChoroplethChart") {
        this.ChoroplethChart.isActive = true
        // this.ChoroplethChart.plotChart()
      }
      else if (this.chartName == "NetworkChart") {
        // this.NetworkChart.isActive = true
      }
      else if (this.chartName == "bubbleMapDiv") {
        this.bubbleChart.isActive = true;
        // this.bubbleChart.getBubbleChartData()
        // this.bubbleChart.plotChart()
      } else if (this.chartName == "barGridDiv") {
        this.SparklinesGrid.isActive = true;
      } else if (this.chartName == "comboBar") {
        this.comboBar.isActive = true;
        this.comboBar.plotChart()
      } else if (this.chartName == "wordCloud") {
        this.wordColud.isActive = true;
        this.wordColud.plotChart()
      } else if (this.chartName == "GroupHBar") {
        this.GroupedHbar.isActive = true;
        this.GroupedHbar.plotChart()
      } else if (this.chartName == "smallBar") {
        this.smallBar.isActive = true;
        this.smallBar.plotChart()
      } else if (this.chartName == "BulletChartDiv") {
        this.bulletChart.isActive = true;
        this.bulletChart.plotChart()
      }
      else if (this.chartName == "areaLineChart") {
        this.areaLine.isActive = true;
        this.areaLine.plotChart()
      }
      // else if (this.chartName == "stackedComboBar") {
      //   this.stackedComboBar.isActive = true;
      //   this.stackedComboBar.plotChart()
      // }
      else if (this.chartName == "slopeChartDiv") {
        this.slopeChart.isActive = true;
        this.slopeChart.plotChart()
      } else if (this.chartName == "HBarChartDiv") {
        this.HBarChart.isActive = true;
        this.HBarChart.plotChart()
      } else if (this.chartName == "BasicHeatMapChartDiv") {
        this.basicHeatMap.isActive = true;
        this.basicHeatMap.plotChart()
      } else if (this.chartName == "kpiBreakdownChartDiv") {
        this.KpiHeatMap.isActive = true;
        this.KpiHeatMap.plotChart()
      } else if (this.chartName == "controlChartDiv") {
        d3.select("#d3pincontrolChartTooltip")
          .style('visibility', 'hidden')
        d3.select("#d3controlChartTooltip")
          .style('visibility', 'hidden');
        d3.select("#d3annotationsTooltip")
          .style('visibility', 'hidden');
        this.controlChart.isActive = true;
        this.controlChart.plotChart()
      } else if (this.chartName == "StackAreaBar") {
        this.StackAreaBar.isActive = true;
        this.StackAreaBar.plotChart()
      }
      else if (this.chartName == "TerritoryDiv") {
        // this.TerritoryMap.isActive = true;
      }

      this.isFullscreen = true
      this.isActive = true
      this.screenChanges.emit(this.isFullscreen);
    }, 100);
  }

  @HostListener('fullscreenchange')
  @HostListener('webkitfullscreenchange')
  @HostListener('mozfullscreenchange')
  @HostListener('MSFullscreenChange')
  screenChange() {
    this.isFullscreen = !!document.fullscreenElement;
    if (!this.isFullscreen) {
      this.expandChart = false;
    }
    // Restore PHI security overlay to correct position if needed
    // if (this.phiChecked && this.phiSecurityService.isRestrictionsEnabled()) {
    //   this.phiSecurityService.showPHIWarningOverlay();
    // }
  }

  closeFullscreen(): void {
    this.settingpopup = false;
    this.isFullscreen = false;
    this.isActive = false;
    this.expandChart = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    if (this.chartName == "bubbleMapDiv") {
      this.bubbleChart.isActive = true;
      // this.bubbleChart.getBubbleChartData()
    }
    //  else if (this.chartName == "ChordChartDiv") {
    //     this.chordChartRef.isActive = false;
    //     this.chordChartRef.isFullscreen = false;
    //     this.chordChartRef.redraw();
    // }
    this.screenChanges.emit(this.isFullscreen);

    // Restore PHI security overlay to normal body position if needed
    // if (this.phiChecked && this.phiSecurityService.isRestrictionsEnabled()) {
    //   this.phiSecurityService.showPHIWarningOverlay();
    // }
  }

  showByChanges(ShowBy: any, fieldName: any) {
    if (ShowBy == 'tablets') {
      return fieldName
    } else {
      return "number_of_bottles"
    }
  }

  // underline data popup method for all chart
  openDialog() {
    if (this?.excelConfig?.length > 0) {
      this.columnDefs = [];
      this.excelConfig.forEach((f: any) => {
        let colDef: any = {
          field: f.key,
          headerName: f.header
        }

        colDef['cellStyle'] = { textAlign: 'left' }

        if (f.type == 'number') {
          colDef['valueFormatter'] = (params: any) => this.numberPipe.transform(params.value);
          colDef['cellStyle'] = { textAlign: 'right' }
        } else if (f.format == 'currency') {
          colDef['valueFormatter'] = (params: any) => this.currency.transform(params.value);
          colDef['cellStyle'] = { textAlign: 'right' }
        }

        if (f.type == 'date') {
          colDef['valueFormatter'] = (params: any) => moment(params.value).format('MM-DD-YYYY');
          colDef['cellStyle'] = { textAlign: 'center' }
        }

        this.columnDefs.push(colDef);
      })

      this.gridData = this.data;
      this.pivot = false;
      this.dialogService.openDialog(this.prompt)
      return
    }

    var val = this.item.config?.time_cycle ? this.item.config?.time_cycle?.find((f: any) => f.value == (this.filterService?.report_type || 'D')) : undefined
    if (this.chartName == "lineChart") {
      this.columnDefs = [
        { field: (this.item.config.list_of_api.api_key == 100133 && this.filterService.showByKey == "N") ? this.item.config["show_by_ndc"]["api_resp_column_nm"] : this.item.config.l1_col['api_resp_column_nm'], rowGroup: true },
        { field: this.item.config.x_axis_column_2['api_resp_column_nm'], cellStyle: { textAlign: 'center' }, pivot: true },
        { field: ((this.item.config.list_of_api.api_key == 100133) || (this.item.config.list_of_api.api_key == 100196)) ? this.item.config.value_column_2['api_resp_column_nm'] : this.showByChanges(this.LineChart.showBy, this.item.config.value_column_2['api_resp_column_nm']), aggFunc: 'sum', cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.item.config.list_of_api.api_key == 100196 ? this.currency.transform(params.value) : this.numberPipe.transform(params.value) },
      ];
      this.gridData = this.data
      this.pivot = true
    } else if (this.chartName == "clusterBarChart") {
      this.columnDefs = [
        { field: "source_name", rowGroup: true },
        { field: "period", cellStyle: { textAlign: 'center' }, pivot: true },
        { field: 'difference', aggFunc: 'sum', cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ];
      this.gridData = this.data
      this.pivot = true
    } else if (this.chartName == "IRSummery") {
      this.columnDefs = [
        { field: 'source_name', rowGroup: true, sort: 'asc' },
        { field: 'period', cellStyle: { textAlign: 'center' }, pivot: true, pivotComparator: (valueA: any, valueB: any) => valueB.localeCompare(valueA) },
        { field: 'qty_difference', aggFunc: 'sum', cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ];
      this.gridData = this.data
      this.pivot = true
    }
    else if (this.chartName == "barChart") {
      let val = this.item.config?.time_cycle.find((f: any) => f.value == (this.filterService.report_type || 'D'))
      this.columnDefs = [
        { headerName: "Shipment Date", field: this.item.config.list_of_api_col_2[0]['api_resp_column_nm'], valueFormatter: (params: any) => moment(params.value).format(val.format || 'DD/MM/YYYY'), cellStyle: { "text-align": "center" } },
        { headerName: "Quantity Shipped", field: this.item.config.list_of_api_col_2[1]['api_resp_column_nm'], cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        // { headerName: this.BarChart.showBy == "tablets" ? "Quantity Shipped("+ this.BarChart.showBy +")" : "Quantity Shipped("+ this.BarChart.showBy +")", field: this.item.config.list_of_api_col_2[1]['api_resp_column_nm'], cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        { field: this.item.config.list_of_api_col_2[2]['api_resp_column_nm'], cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ];
      // this.LineChart.showBy =="tablets" ? this.item.config.list_of_api_col_2[1]['api_resp_column_nm']: "number_of_bottles"
      this.gridData = this.data[0] // this.BarChart.showBy =="tablets" ? this.data[0] : this.BarChart.data
      this.pivot = false
    } else if (this.chartName == "bubbleMapDiv") {
      let val = this.item.config?.time_cycle.find((f: any) => f.value == (this.filterService.report_type || 'D'))
      this.columnDefs = [
        { headerName: "Shipment Date", field: "period", valueFormatter: (params: any) => moment(params.data.period).format(val.format || 'DD MMM YYYY'), cellStyle: { "text-align": "center" } },
        { headerName: "Source Name", field: "sourcename", cellStyle: { "text-align": "center" } },
        { headerName: "Pharmacy Location Name", field: "locationname", cellStyle: { "text-align": "center" } },
        { headerName: "Quantity Shipped", field: "number_of_bottles", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        // { headerName: this.bubbleChart.showBy == "tablets" ? "Quantity Shipped("+this.bubbleChart.showBy+ ")": "Quantity Shipped("+this.bubbleChart.showBy+ ")", field: this.bubbleChart.showBy == "tablets" ? "quantityshipped" : "number_of_bottles", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ];
      this.gridData = this.data

      this.pivot = false
    }
    else if (this.chartName == "comboBar") {
      let userStatedata = this.userActivityService.getData()
      if (this.item.config.chart_type.value == "group") {
        this.columnDefs = [

          { headerName: "Shipment Date", field: "period", valueFormatter: (params: any) => moment(params.value).format(val.format || 'DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
          { headerName: 'Source Name', field: "data_source_name", cellStyle: { "text-align": "center" } },
          { headerName: 'Shipped Patients', field: "shipped_patients", cellStyle: { "text-align": "center" } },
          { headerName: "Quantity Shipped", field: userStatedata.showBy == "tablets" ? "shipped_quantity" : "no_of_bottles", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
          // { headerName: (userStatedata.showBy == "tablets" && userStatedata.showBy != undefined) ? "Quantity Shipped("+this.comboBar.showBy+ ")" : "Quantity Shipped("+this.comboBar.showBy+ ")", field: userStatedata.showBy == "tablets" ? "shipped_quantity" : "no_of_bottles", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        ];
      } else {
        this.columnDefs = [

          { headerName: "Shipment Date", field: "period", valueFormatter: (params: any) => moment(params.value).format(val.format || 'DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
          { headerName: 'Shipments', field: "shipments", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
          { headerName: "Quantity Shipped", field: userStatedata.showBy == "tablets" ? "shipped_quantity" : "no_of_bottles", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
          // { headerName: userStatedata.showBy == "tablets" ? "Quantity Shipped("+this.comboBar.showBy+ ")" : "Quantity Shipped("+this.comboBar.showBy+ ")", field: userStatedata.showBy == "tablets" ? "shipped_quantity" : "no_of_bottles", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        ];
      }
      this.gridData = this.comboBar.data.lineData
      this.pivot = false
    }
    else if (this.chartName == "GanttChart") {
      {
        this.columnDefs = [
          { field: "PatientID", cellStyle: { "text-align": "center" } },
          { field: "Level1", cellStyle: { "text-align": "center" } },
          { field: "Level2", cellStyle: { "text-align": "center" } },
          { field: "Status", cellStyle: { "text-align": "center" } },
          { field: "StatusGroup", cellStyle: { "text-align": "center" } },
          { field: "SubStatusgroup", cellStyle: { "text-align": "center" } },
          { field: "StatusReason", cellStyle: { "text-align": "center" } },
          { field: "TransactionID", cellStyle: { "text-align": "center" } },
          { field: "TransactionDate", valueFormatter: (params: any) => moment(params.value).format('DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
          { field: "startDate", valueFormatter: (params: any) => moment(params.value).format('DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
          { field: "endDate", valueFormatter: (params: any) => moment(params.value).format('DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
          { field: "TransactionType", cellStyle: { "text-align": "center" } },
          { field: "TransactionName", cellStyle: { "text-align": "center" } },
          { field: "name", cellStyle: { "text-align": "center" } },
          { field: "rootParent", cellStyle: { "text-align": "center" } },
          { field: "descendantIndex", cellStyle: { "text-align": "center" } },
        ];
      }

      this.gridData = this.data
      this.pivot = false
    }
    else if (this.chartName == "NetworkChart") {

      this.columnDefs = [
        { field: "node_1", headerName: 'Node 1', cellStyle: { "text-align": "center" } },
        { field: "node_2", headerName: 'Node 2', cellStyle: { "text-align": "center" } },
        { field: "node_3", headerName: 'Node 3', cellStyle: { "text-align": "center" } },
        { field: "node_4", headerName: 'Node 4', cellStyle: { "text-align": "center" } },
        { field: "node_5", headerName: 'Node 5', cellStyle: { "text-align": "center" } },
        { field: "node_6", headerName: 'Node 6', cellStyle: { "text-align": "center" } }
      ];

      // Get the value from the dropdown
      // const data: any = document.getElementById('sortBy');

      // Define a function to add columns based on the selected option
      const addColumns = (columns: any[]) => {
        this.columnDefs = [...this.columnDefs, ...columns];
      };

      this.networkExcelDropdownData[0].option;
      const data = this.networkExcelDropdownData[0].values;
      
      let dynamicUnderlineData:any = [];
      data.forEach((el:any) => {
        const ab = {
          field: el.keyName,
          headerName: el.name
        }
        dynamicUnderlineData.push(ab);
      });

      addColumns(dynamicUnderlineData);

      // Determine columns to add based on the dropdown value
      // switch (data.value) {
      //   case "Indication":
      //     addColumns([
      //       { field: "ind_flag_ad", headerName: 'AD' },
      //       { field: "ind_flag_asthma", headerName: 'Asthma' },
      //       { field: "ind_flag_np", headerName: 'NP' },
      //       { field: "ind_flag_eoe", headerName: 'EOE' },
      //       { field: "ind_flag_pn", headerName: 'PN' },
      //       { field: "ind_flag_csu", headerName: 'CSU' },
      //       { field: "ind_flag_copd", headerName: 'COPD' },
      //       { field: "ind_flag_na", headerName: 'NA' },
      //       { field: "ind_flag_un_known_derm", headerName: 'Unknown Derm' },
      //       { field: "ind_flag_un_known_pulm", headerName: 'Unknown Pulm' }
      //     ]);
      //     break;
      //   case "Referral Source":
      //     addColumns([
      //       { field: "referral_source_sp", headerName: 'SP' },
      //       { field: "referral_source_hub", headerName: 'HUB' }
      //     ]);
      //     break;
      //   case "Rx Type":
      //     addColumns([
      //       { field: "rx_type_refill", headerName: 'Rx Type Refill' },
      //       { field: "rx_type_new", headerName: 'Rx Type NEW' }
      //     ]);
      //     break;
      //   case "Days Waiting":
      //     addColumns([
      //       { field: "days_wt_period_1", headerName: 'DAYS 1-7' },
      //       { field: "days_wt_period_2", headerName: 'DAYS 8-21' },
      //       { field: "days_wt_period_3", headerName: 'DAYS 22-90' },
      //       { field: "days_wt_period_4", headerName: 'DAYS > 90' }
      //     ]);
      //     break;
      //   default:
      //     addColumns([
      //       { field: "patient_count", headerName: 'Patient Count' },
      //       { field: "lagging_patients", headerName: 'Lagging Patients' }
      //     ]);
      //     break;
      // }

      // Add common columns at the end
      addColumns([
        { field: "avg_days", headerName: 'Average Days' },
        { field: "process", headerName: 'Process' },
        { field: "seq_no", headerName: 'Sequence Number' }
      ]);

      // Set text alignment for all columns
      this.columnDefs.forEach((col: any) => col.cellStyle = { "text-align": "center" });

      this.gridData = this.NetworkChartData;
      this.pivot = false;
    }
    else if (this.chartName == "ChoroplethChart") {
      this.columnDefs = [
        { field: "hco_npi_key", headerName: 'HCO NPI Key', cellStyle: { "text-align": "center" } },
        // { field: "patient_id", headerName: 'Patient ID', cellStyle: { "text-align": "center" } },
        // { field: "prescriber_ID", headerName: 'Prescriber ID', cellStyle: { "text-align": "center" } },
        // { field: "location_name", headerName: 'Location Name', cellStyle: { "text-align": "center" } },
        { field: "account_name", headerName: 'Account Name', cellStyle: { "text-align": "center" } },
        { field: "email", headerName: 'Email', cellStyle: { "text-align": "center" } },
        // { field: "prescriber_address", headerName: 'Link Label', cellStyle: { "text-align": "center" } },
        { field: "state_cd", headerName: 'State Code', cellStyle: { "text-align": "center" } },
        { field: "zip_code", headerName: 'Zip Code', cellStyle: { "text-align": "center" } },
        { field: "pending_patient", headerName: 'Pending Patient', cellStyle: { "text-align": "center" } },
        { field: "lagging_patient", headerName: 'Lagging Patient', cellStyle: { "text-align": "center" } },
      ];
      this.gridData = this.choroDeta
      this.pivot = false
    } else if (this.chartName == "wordCloud") {
      let api_key = this.item?.config?.list_of_api?.api_key
      this.columnDefs = [
        { headerName: (api_key == 100711 || api_key == 100172) ? 'Source Name' : 'Field Name', field: (api_key == 100172) ? 'data_source_name' : "field_name", cellStyle: { "text-align": "center" } },
        { headerName: api_key == 100711 ? 'Merge Activity Count' : 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ];
      if (this.item.config.list_of_api_col_2.length > 0) {
        this.columnDefs = []
        for (let i = 0; i < this.item.config.list_of_api_col_2.length; i++) {
          this.columnDefs.push({
            "headerName": this.item.config.list_of_api_col_2[i].api_resp_column_display_nm,
            "field": this.item.config.list_of_api_col_2[i].api_resp_column_nm,
            valueFormatter: (params: any) => (typeof (params.value) == 'number') ? this.numberPipe.transform(params.value) : params.value,
            cellStyle: { "text-align": "center" },
          });
        }

      }
      this.gridData = this.data
      this.pivot = false
    }
    else if (this.chartName == "clusterstatic") {
      let api_key = this.item?.config?.list_of_api?.api_key

      if (this.item.config.list_of_api_col_2.length > 0) {
        this.columnDefs = []
        for (let i = 0; i < this.item.config.list_of_api_col_2.length; i++) {
          this.columnDefs.push({
            "headerName": this.item?.config?.surfix == '%' && this.item.config.list_of_api_col_2[i].api_resp_column_display_nm == 'Count' ? "Percentage" : this.item.config.list_of_api_col_2[i].api_resp_column_display_nm,
            "field": this.item.config.list_of_api_col_2[i].api_resp_column_nm,
            valueFormatter: (params: any) => (typeof (params.value) == 'number') ? this.numberPipe.transform(params.value) + (this.item?.config?.surfix || '') : params.value,
            cellStyle: { "text-align": "center" },
          });
        }

      }
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "GroupHBar") {
      if (this.item.config.list_of_api == 100175) {
        this.columnDefs = [
          { headerName: 'File Type', field: "file_type_name", cellStyle: { "text-align": "center" } },
          { headerName: 'Result type', field: "error_type_code", cellStyle: { "text-align": "center" } },
          { headerName: 'Defect Range', field: "range_nm", cellStyle: { "text-align": "center" } },
          { headerName: 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        ];
      } else {
        this.columnDefs = [
          { headerName: 'Source Name', field: "data_source_name", cellStyle: { "text-align": "center" } },
          { headerName: 'Result type', field: "error_type_code", cellStyle: { "text-align": "center" } },
          { headerName: 'Defect Range', field: "range_nm", cellStyle: { "text-align": "center" } },
          { headerName: 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        ];
      }
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "smallBar") {
      if (this.item.config.chart_type == "onebar") {

        this.columnDefs = this.item.config.list_of_api?.api_key == 100609 || this.item.config.list_of_api == 100609 ? [
          { headerName: 'Date', field: "period", cellStyle: { "text-align": "center" } },
          { headerName: 'Time to Therapy', field: "time_to_therapy", cellStyle: { "text-align": "center" } },
        ] : [
          { headerName: 'Field Name', field: "field_name", cellStyle: { "text-align": "center" } },
          { headerName: 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        ];
      } else {
        this.columnDefs = [
          { headerName: 'File Name', field: "file_type_name", cellStyle: { "text-align": "center" } },
          { headerName: 'Result type', field: "error_type", cellStyle: { "text-align": "center" } },
          { headerName: 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
        ];
      }
      if (this.item.config.list_of_api_col_2.length > 0) {
        this.columnDefs = []
        for (let i = 0; i < this.item.config.list_of_api_col_2.length; i++) {
          this.columnDefs.push({
            "headerName": this.item?.config?.surfix == '%' && this.item.config.list_of_api_col_2[i].api_resp_column_display_nm == 'Count' ? "Percentage" : this.item.config.list_of_api_col_2[i].api_resp_column_display_nm,
            "field": this.item.config.list_of_api_col_2[i].api_resp_column_nm,
            valueFormatter: (params: any) => (typeof (params.value) == 'number') ? this.numberPipe.transform(params.value) + (this.item?.config?.surfix || '') : params.value,
            cellStyle: { "text-align": "center" },
          });
        }

      }
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "areaLineChart") {
      this.columnDefs = [
        { headerName: 'Date', field: "period", valueFormatter: (params: any) => moment(params.value).format(val?.format || 'DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
        { headerName: 'No of Days', field: "no_of_days", cellStyle: { "text-align": "center" } },
        { headerName: 'Result Type', field: "error_type", cellStyle: { "text-align": "center" } },
        { headerName: 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ]

      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "stackedComboBar") {
      this.columnDefs = this.item.config.list_of_api.api_key == 100171 ? [
        { headerName: 'Date', field: "period", valueFormatter: (params: any) => moment(params.value).format(val?.format || 'DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
        { headerName: 'No of Days', field: "no_of_days", cellStyle: { "text-align": "center" } },
        { headerName: 'Result Type', field: "error_type", cellStyle: { "text-align": "center" } },
        { headerName: 'Defect Count', field: "defect_count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ] : [
        { headerName: 'Date', field: "quarter_date", valueFormatter: (params: any) => moment(params.value).format(val?.format || 'DD-MMM-YYYY'), cellStyle: { "text-align": "center" } },
        { headerName: 'Category Name', field: "category_name", cellStyle: { "text-align": "center" } },
        { headerName: 'Return Rate', field: "return_rate", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => params.value + "%" },
        { headerName: 'Count', field: "count", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.numberPipe.transform(params.value) },
      ];
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "slopeChartDiv") {

      //   let data :any=[]
      //    this.slopeChart.slopeFormattedData.forEach((element:any) => {
      //     element[1].forEach((val:any) => {
      //   data.push({'source_name' :element[0],'kpi_name':val.xVar,'kpi_value':val.yVal})
      // });
      //    });

      this.columnDefs = [
        { headerName: ' ', field: this.item.config.chart_type == 'scorecard' ? 'source_name' : "brand_name", cellStyle: { "text-align": "center" }, rowGroup: true },
        { field: 'kpi_name', pivot: true },
        {
          field: 'kpi_value', aggFunc: (params: any) => {
            let total: any = 0;
            let value: any = 0
            params.values.forEach((value: any) => total += value);
            if (typeof total != 'number') {
              if (params.values.length > 1) {
                total = total.slice(1);
                total = total.split('%')
                total.pop()
                total = total.forEach((v: any) => value += parseInt(v));
                total = (value / params.values.length) + '%'
              } else {
                total = total.slice(1);
              }
              return total;
            } else {

              return this.currency.transform(total, '', '', '1.0-2')
            }
          }, cellStyle: { "text-align": "center" }
        }
      ];

      this.gridData = this.item.config.list_of_api == "100195" ? this.data : this.slopeChart.slopeChartFormattedData
      this.pivot = true
      this.dateFormat = false
    } else if (this.chartName == "HBarChartDiv") {

      this.columnDefs = this.item.config.chart_type == 'small' ? [
        { headerName: 'Field Name', field: "field_name", cellStyle: { "text-align": "center" } },
        { headerName: 'This Account', field: "this_account", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },
        { headerName: 'Network', field: "network", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },
      ] : [
        { headerName: 'Brand Name ', field: "brand_name", cellStyle: { "text-align": "center" } },
        { headerName: 'Amount Per Record', field: "amount_per_record", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value) },
      ]
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "BulletChartDiv") {
      if (this.item.config['chart_type'] == 'bullet') {

        this.columnDefs = [
          { headerName: 'Date ', field: "qtr_end_date", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => params.value ? moment(params.value).format('DD MMM YYYY') : '', },
          { headerName: 'File Type', field: "file_type_name", cellStyle: { "text-align": "center" } },
          { headerName: 'Max Records', field: "max_records", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },
          { headerName: 'Current Records', field: "actual_records", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },
          { headerName: 'Buffer Records', field: "buffer_records", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },
          { headerName: 'Buffer percentage', field: "buffer_pct", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => params.value ? params.value + '%' : "0%" },

        ];
      } else {
        this.columnDefs = [
          { headerName: 'Date ', field: "qtr_end_date", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => moment(params.value).format('DD MMM YYYY'), },
          { headerName: 'File Type', field: "file_type", cellStyle: { "text-align": "center" } },
          { headerName: 'Target Payment', field: "max_payment", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.enhancementService.currentQuarterFlag ? '-' : this.currency.transform(params.value) },
          { headerName: 'Payment after corrections', field: "corrected_amount", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.enhancementService.currentQuarterFlag ? '-' : this.currency.transform(params.value) },
          { headerName: 'Delay Penalty', field: "delay_penalty", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.enhancementService.currentQuarterFlag ? '-' : params.value + "%" },
          { headerName: 'Payment Earned', field: "amount_payable", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.enhancementService.currentQuarterFlag ? '-' : this.currency.transform(params.value) },

        ];
      }

      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "kpiBreakdownChartDiv") {
      this.columnDefs = [
        { headerName: 'Source Name', field: "source_name", cellStyle: { "text-align": "center" }, },
        { headerName: 'KPI Name', field: "kpi_name", cellStyle: { "text-align": "center" } },
        { headerName: 'Source Type', field: "source_type", cellStyle: { "text-align": "center" } },
        { headerName: 'KPI Value', field: "kpi_value", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },

      ];
      this.gridData = this.KpiHeatMap.data
      this.pivot = false
    } else if (this.chartName == "controlChartDiv") {

      let api_key = this.item?.config?.list_of_api?.api_key || this.item?.config?.list_of_api;

      this.columnDefs = [
        { headerName: 'Time Period', field: "period", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => moment(params.value).format('DD MMM YYYY'), },
        { headerName: 'KPI Name', field: "kpi_nm", cellStyle: { "text-align": "center" }, },
        { headerName: (api_key == 999999) ? 'X Axis' : 'Source Name', field: (api_key == 999999) ? 'x_axis_value' : "source_name", cellStyle: { "text-align": "center" } },
        { headerName: 'KPI Value', field: "kpi_value", cellStyle: { "text-align": "center" }, valueFormatter: (params: any) => this.currency.transform(params.value, '', '', '1.0-2') },

      ];
      this.gridData = this.controlChart.ControlChartData.data
      this.pivot = false
    } else if (this.chartName == "vennChartDiv") {

      this.columnDefs = [
        { headerName: 'Patient Id', field: "patient_id", cellStyle: { "text-align": "center" }, },
        { headerName: 'Service Type', field: "service_type", cellStyle: { "text-align": "center" } },

      ];
      // debugger
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "pieChartDiv") {

      this.columnDefs = [
        { headerName: 'Status', field: this.item?.['config']?.['chart_type']?.name == 'DonutpieChart' ? "type" : "category", cellStyle: { "text-align": "center" }, },
        { headerName: 'Value', field: "value", cellStyle: { "text-align": "center" } },

      ];
      // debugger
      this.gridData = this.data
      this.pivot = false
    } else if (this.chartName == "donutPieChartDiv") {

      this.columnDefs = [
        { headerName: 'Payer Type ', field: "label", cellStyle: { "text-align": "center" }, },
        { headerName: 'Sub Type', field: "type", cellStyle: { "text-align": "center" } },
        { headerName: 'Value', field: "value", cellStyle: { "text-align": "center" } },

      ];
      // debugger
      this.gridData = this.data
      this.pivot = false
    }
    let headerId: any = this.heading.replaceAll(' ', '') == '' ? 'header' : this.sanitizeId(this.heading)
    const element = document.querySelector('#' + headerId);
    if (element) {
      // console.log(element.textContent); // Output the text content to console
      this.SubHeading = element.textContent
    } else {
      this.SubHeading = ' '
    }
    this.dialogService.openDialog(this.prompt)
  }
  sanitizeId(heading: string): string {
    if (!heading) return 'header';
    return this.replacePlaceholders(heading)
      .replace(/[^a-zA-Z0-9_-]/g, '')   // keep only letters, numbers, _ and -
      .replace(/^-+|-+$/g, '');   // trim leading/trailing dashes
  }
  controlChartPopup(icon: any) {
    this.columnDefs = []
    this.gridData = []
    this.clicked = false
    let postData: any = { report_typ: "D", api_key: "1001851" };
    //  api_key: "10018503" generalapi key
    if (this.filterService?.dragDate?.length > 0) {
      postData['from_date'] = moment(this.filterService.dragDate[0]).format('yyyy-MM-DD')
      postData['to_date'] = moment(this.filterService.dragDate[1]).format('yyyy-MM-DD')
    }
    this.dialogService.openDialog(this.controlPopup)
    this.reqSubcription.push(this.filterService.dragexecuteQuery(postData, (icon["filter_var"] || 'y_axis_key')).subscribe(
      (res: any) => {
        if (res.length == 0) { this.columnDefs = [], this.gridData = [], this.clicked = true; return }
        let coldef = Object.keys(res[0])
        coldef.forEach((element: any) => {
          this.columnDefs.push({ headerName: element.toUpperCase().replaceAll('_', ' '), field: element, cellStyle: { "text-align": "center" } })
        });
        this.columnDefs = [...new Set(this.columnDefs)]
        this.clicked = true
        this.gridData = res
        this.pivot = false
        this.pagination = true
      },
      (err: any) => {
        this.columnDefs = []
        this.gridData = []
        this.clicked = true
        let errorMsg = friendlyApiErrorMessage(err)
        this.dialogService.openSnackBar(errorMsg, "OK")
      }
    ))

  }

  // Export to excel  for all chart
  excelExport() {
    var columns: any
    const cfg = this.item.config;

    if (this.excelConfig?.length > 0) {
      // debugger
      this.excelService.customExportExcel(this.data, cfg['report_heading'], this.excelConfig)
      return;
    }
    if (cfg?.excel_column?.columns?.length > 0) {
      // debugger
      this.excelService.customExportExcel(this.data, (cfg['report_heading']||cfg['excel_heading']), cfg?.excel_column?.columns)
      return;
    }

    /////////////////////

    if (this.chartName == "lineChart") {
      this.excelService.customExportExcel(this.data, this.item.config["list_of_api"].api_key == 100133 ? this.filterService.baseQuery.source_nm + "-" + this.item.config['excel_heading'] : this.item.config['excel_heading'], this.item.config.excel_column)
    } else if (this.chartName == "barChart") {
      // this.data = this.data[0]
      this.excelService.customExportExcel(this.data[0], this.item.config['report_heading'], this.item.config.excel_column)
    }
    else if (this.chartName == "clusterBarChart") {
      let colDef: any = [
        {
          "header": "Date",
          "key": "period",
          "type": "date",
        },
        {
          "header": "Source Name",
          "key": "source_name",
          "type": "string",
        },
        // {
        //   "header": "Location Name",
        //   "key": "sp_location_name",
        //   "type": "string",
        // },
        // {
        //   "header": "NDC",
        //   "key": "ndc_product_form",
        //   "type": "string",
        // },
        {
          "header": "Dispense Quantity",
          "key": "dispense_qty",
          "type": "number",
        },
        {
          "header": "Inventory Quantity",
          "key": "inventory_qty",
          "type": "number",
        },
        {
          "header": "Difference",
          "key": "difference",
          "type": "number",
        },
        {
          "header": "Inventory On Hand",
          "key": "inventory_on_hand",
          "type": "number",
        },
      ]
      this.excelService.customExportExcel(this.data, this.filterService.baseQuery.source_nm + "-" + this.item.config['report_heading'], colDef)
    } else if (this.chartName == "IRSummery") {
      // let colDef: any = [
      //   {
      //     "header": "Date",
      //     "key": "period",
      //     "type": "date",
      //   },
      //   {
      //     "header": "Source Name",
      //     "key": "source_name",
      //     "type": "string",
      //   },         
      //   {
      //     "header": "Dispense Quantity",
      //     "key": "dispense_qty",
      //     "type": "number",
      //   },
      //   {
      //     "header": "Inventory Quantity",
      //     "key": "inventory_qty",
      //     "type": "number",
      //   },
      //         {
      //     "header": "Difference",
      //     "key": "qty_difference",
      //     "type": "number",
      //   },
      //   {
      //     "header": "Difference Percentage",
      //     "key": "pct_difference",
      //     "type": "percent",
      //   },
      //   {
      //     "header": "Inventory On Hand",
      //     "key": "inventory_on_hand",
      //     "type": "number",
      //   },
      // ]
      if (this.item.config?.excel_column && this.item.config?.excel_column?.length > 0) {
        this.excelService.customExportExcel(this.data, this.item.config['report_heading'], this.item.config.excel_column)
      } else {
        this.excelService.exportAsExcelFile(this.data, this.item.config['report_heading'])
      }
    } else if (this.chartName == "bubbleMapDiv") {
      this.data = this.data
      this.item.config.excel_column = [
        {
          "header": "Shipment Date",
          "type": "date",
          "key": "period"
        },
        {
          "header": "Source Name",
          "type": "string",
          "key": "sourcename"
        },
        {
          "header": "Pharmacy Location Name",
          "type": "string",
          "key": "locationname"
        },
        // {
        //     "header": "Quantity Shipped(Tablets)",
        //     "type": "string",
        //     "key": "quantityshipped"
        // },
        {
          "header": "Quantity Shipped",
          "key": "number_of_bottles",
          "type": "number"
        }
      ]
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], this.item.config.excel_column)
    }
    else if (this.chartName == 'GanttChart') {
      this.excelService.exportAsExcelFile(this.data, this.item.config['report_heading'])

    }
    else if (this.chartName == 'NetworkChart') {
      this.excelService.exportAsExcelFile(this.NetworkChartData, this.item.config['report_heading'])

    }
    else if (this.chartName == 'ChoroplethChart') {
      this.excelService.exportAsExcelFile(this.choroDeta, this.item.config['report_heading'])

    }
    else if (this.chartName == 'comboBar') {
      let colDef: any
      if (this.item.config.chart_type.value == "group") {
        colDef = [
          {
            "header": "Time Period",
            "key": "period",
            "type": "date",
          },
          {
            "header": "Source Name",
            "key": "data_source_name",
            "type": "string",
          },
          {
            "header": "Shipped Patient",
            "key": "shipped_patients",
            "type": "string",
          },
          // {
          //   "header": "Quantity Shipped(Tablets)",
          //   "key": "shipped_quantity",
          //   "type": "string",
          // },
          {
            "header": "Quantity Shipped",
            'key': "no_of_bottles",
            "type": "number"
          }
        ]
      } else {
        colDef = [
          {
            "header": "Time Period",
            "key": "period",
            "type": "date",
          },
          {
            "header": "Shipments",
            "key": "shipments",
            "type": "string",
          },
          // {
          //   "header": "Quantity Shipped(Tablets)",
          //   "key": "shipped_quantity",
          //   "type": "string",
          // },
          {
            "header": "Quantity Shipped",
            'key': "no_of_bottles",
            "type": "number"
          }
        ]
      }
      this.excelService.customExportExcel(this.comboBar.data.lineData, this.item.config['report_heading'], colDef)
      // this.excelService.exportAsExcelFile(this.comboBar.data.lineData, this.item.config['report_heading'])
      // this.excelService.customExportExcel(this.comboBar.data.lineData, this.item.config['report_heading'], colDef)
    }
    else if (this.chartName == "wordCloud") {
      let api_key = this.item?.config?.list_of_api?.api_key

      let colDef: any = [
        {
          "header": "Field Name",
          "key": "field_name",
          "type": "string",
        },
        {
          "header": "Defect Count",
          "key": "defect_count",
          "type": "string",
        },

      ]

      colDef = this.item.config.excel_column.length > 0 ? this.item.config.excel_column : colDef
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], this.item.config.excel_column ? this.item.config.excel_column : colDef)

    } else if (this.chartName == "GroupHBar") {
      let colDef: any = [
        {
          "header": "	Source Name",
          "key": "data_source_name",
          "type": "string",
        },
        {
          "header": "Result type",
          "key": "error_type_code",
          "type": "string",
        },
        {
          "header": "Defect Range",
          "key": "range_nm",
          "type": "string",
        },
        {
          "header": "Defect Count",
          "key": "defect_count",
          "type": "string",
        },
        {
          "header": "Result type description",
          "key": "dv_error_type_desc",
          "type": "string",
        }
      ]
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    } else if (this.chartName == "smallBar") {
      let colDef: any
      if (this.item.config.chart_type == "onebar") {

        colDef = this.item.config.list_of_api?.api_key == 100609 || this.item.config.list_of_api == 100609 ? [
          {
            "header": "Date",
            "key": "period",
            "type": "date",
          },
          {
            "header": "Time to Therapy",
            "key": "time_to_therapy",
            "type": "string",
          },] : [
          {
            "header": "Field Name",
            "key": "field_name",
            "type": "string",
          },
          {
            "header": "Defect Count",
            "key": "defect_count",
            "type": "string",
          },
        ]
      } else {
        colDef = [
          {
            "header": "File Name",
            "key": "file_type_name",
            "type": "string",
          },
          {
            "header": "Result type",
            "key": "error_type",
            "type": "string",
          },
          {
            "header": "Defect Count",
            "key": "defect_count",
            "type": "string",
          },
        ]
      }
      colDef = this.item.config.excel_column.length > 0 ? this.item.config.excel_column : colDef
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    } else if (this.chartName == "stackedComboBar") {
      let colDef: any = [
        {
          "header": "Defect received date",
          "key": "period",
          "type": "date",
        },
        {
          "header": "Result type",
          "key": "error_type",
          "type": "string",
        },
        {
          "header": "Defect Count",
          "key": "defect_count",
          "type": "string",
        },
      ]
      colDef = this.item.config.excel_column.length > 0 ? this.item.config.excel_column : colDef
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    } else if (this.chartName == "clusterstatic") {
      let colDef: any = [
        {
          "header": "Defect received date",
          "key": "period",
          "type": "date",
        },
        {
          "header": "Result type",
          "key": "error_type",
          "type": "string",
        },
        {
          "header": "Defect Count",
          "key": "defect_count",
          "type": "string",
        },
      ]
      colDef = this.item.config.excel_column.length > 0 ? this.item.config.excel_column : colDef
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    } else if (this.chartName == "areaLineChart") {
      let colDef: any = [
        {
          "header": "Defect received date",
          "key": "date",
          "type": "string",
        },
        {
          "header": "Result type",
          "key": "error_type",
          "type": "string",
        },
        {
          "header": "Defect Count",
          "key": "defect_count",
          "type": "string",
        },
        {
          "header": "Response time(In days)",
          "key": "no_of_days",
          "type": "string",
        },

      ]
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    } else if (this.chartName == "slopeChartDiv") {

      let colDef: any = [
        {
          "header": "Time period",
          "key": " period",
          "type": "date",
        },
        {
          "header": "Source Name",
          "key": "source_name",
          "type": "string",
        },
        {
          "header": "KPI Value",
          "key": "kpi_value",
          "type": "string",
        },
        {
          "header": "KPI Name",
          "key": "kpi_name",
          "type": "string",
        },
        {
          "header": "KPI Type",
          "key": "kpi_type",
          "type": "string",
        },

      ]
      this.excelService.customExportExcel(this.item.config.list_of_api == "100195" ? this.data : this.slopeChart.slopeChartFormattedData, this.item.config['report_heading'], colDef)
    } else if (this.chartName == "GridList") {
      let colDef: any
      if (this.item.config?.list_of_api?.api_key == 100200) {
        colDef = [
          {
            "header": "Field Name",
            "key": "business_column_name",
            "type": "string",
          },
          {
            "header": "DV Check Description",
            "key": "dv_description",
            "type": "string",
          },
          // {
          //   "header": "Applicable Source",
          //   "key": "source_name",
          //   "type": "string",
          // },
          {
            "header": "DV Check Result type",
            "key": "dv_error_type",
            "type": "string",
          },
          {
            "header": "DV Check Sequence",
            "key": "dv_check_sequence",
            "type": "string",
          },
          // {
          //   "header": "DV Check Error Message",
          //   "key": "dv_error_message",
          //   "type": "string",
          // }
        ]
        this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
      } else {
        this.exportXls.emit(true)

        // this.filterService.exportXls.next(true);
        // this.excelService.exportAsExcelFile(this.data, this.item.config['report_heading'])
      }
    }
    else if (this.chartName == 'barGridDiv') {
      this.excelService.exportAsExcelFile(this.data, this.sourceName ? (this.filterService.baseQuery.source_nm + " " + "Location" + " " + this.item.config['report_heading']) : this.filterService.baseQuery.source_nm + " " + this.item.config['report_heading'])

    } else if (this.chartName == "HBarChartDiv") {
      let colDef: any = this.columnDefs = this.item.config.chart_type == 'small' ? [
        { header: 'Field Name', key: "field_name", type: "string" },
        { header: 'This Account', key: "this_account", type: "number" },
        { header: 'Network', key: "network", type: "number" },
      ] : [
        {
          "header": "Brand Name",
          "key": "brand_name",
          "type": "string",
        },
        {
          "header": "Amount Per Record",
          "key": "amount_per_record",
          "type": "currency",
        },

      ]
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    }
    else if (this.chartName == 'pivotGrid') {
      this.pivotGrid.exportXls();

    }
    else if (this.chartName == "BulletChartDiv") {
      let colDef: any
      if (this.item.config['chart_type'] == 'bullet') {
        colDef = [
          { header: 'Date ', key: "qtr_end_date", "type": "date", },
          { header: 'File Type', key: "file_type_name", "type": "string", },
          { header: 'Max Records', key: "max_records", "type": "number", },
          { header: 'Current Records', key: "actual_records", "type": "number", },
          { header: 'Buffer Records', key: "buffer_records", "type": "number", },
          { header: 'Buffer percentage', key: "buffer_pct", "type": "percent", }]
      } else {
        colDef = [
          {
            "header": "File Type",
            "key": "file_type",
            "type": "string",
          },
          {
            "header": "Target Payment",
            "key": "max_payment",
            "type": this.enhancementService.currentQuarterFlag ? 'masking' : "currency",
          },
          {
            "header": "Payment after corrections",
            "key": "corrected_amount",
            "type": this.enhancementService.currentQuarterFlag ? 'masking' : "currency",
          },
          {
            "header": "Delay Penalty",
            "key": "delay_penalty",
            "type": this.enhancementService.currentQuarterFlag ? 'masking' : "percent",
          },
          {
            "header": "Payment Earned",
            "key": "amount_payable",
            "type": this.enhancementService.currentQuarterFlag ? 'masking' : "currency",
          },

        ]
      }
      // debugger
      this.excelService.customExportExcel(this.data, this.item.config['report_heading'], colDef)
    }

    else if (this.chartName == 'statusCodesUI') {
      this.statusCodeRef.exportXls();

    }
    else if (this.chartName == "PaymentGrid") {

      this.paymentGrid.exportToExcel()
    } else if (this.chartName == "BasicHeatMapChartDiv") {

      let colDef: any = []
      this.data.columnDetails.forEach((element: any) => {
        colDef.push({
          "header": element.field_display_nm,
          "key": element.field_nm,
          "type": "percentage",
        })

      });
      const columnDef = this.getUniqueListBy(colDef, 'key')

      this.excelService.customExportExcel(this.data.data, this.item.config['report_heading'], columnDef)
      // this.excelService.exportAsExcelFile(this.data.data, this.item.config['report_heading'])
    } else if (this.chartName == "controlChartDiv") {
      this.excelService.exportAsExcelFile(this.controlChart.ControlChartData.data, ('ControlChart' + (this.item.config['excel_heading'] ? ('_' + this.item.config['excel_heading']) : "")))
    } else if (this.chartName == "TerritoryDiv") {
      // let jsonData: any
      // this.apiService.getDoc("territoryMap-data").subscribe((data: any) => {
      //   jsonData = data;
      this.excelService.exportAsExcelFile(this.data, this.item.config['report_heading'])
      // });

    }else if (this.chartName == "DataGrid" && this.item.config?.['list_of_api']?.['api_key'] == "20005") {
   const column =   [
     "client_name",
     "brand_name",
     "extract_type",
     "source_name",
     "file_type",
     "file_status",
     "sent_records",
     "file_nm",
     "delay_ind",
     "cycle_dt",
     "file_receive_cutoff_time",
     "early",
     "delay",
     "time_sent",
     "report_nm"
  ]
      this.excelService.exportAsExcelFile(this.data, this.item.config['report_heading'], column)
    }
    else {
      this.excelService.exportAsExcelFile(this.data, this.item.config['report_heading'])
    }
  }

  expandCollapse() {
    this.dataService.expandCollapseChart.next(!this.expandChart)
    this.expandChart = !this.expandChart
    this.expendCol.emit(this.expandChart)
  }

  pivotexpandCollapse() {
    if (this.expandCollapseIcon == "collapse_new") {
      this.expandCollapseIcon = "gridload_circle"
      this.expandOrCollapse = "Expand All"
      this.pivotGrid.gridApi.collapseAll()

    } else {
      this.expandCollapseIcon = "collapse_new"
      this.expandOrCollapse = "Collapse All"
      this.pivotGrid.gridApi.expandAll();
    }
  }

  getUniqueListBy(arr: any, key: any) {
    return [...new Map(arr.map((item: any) => [item[key], item])).values()]
  }

  isPHIFunc(event: any) {
    this.phiChecked = !this.phiChecked;

    // If PHI is being disabled, also disable watermark mode
    // if (!this.phiChecked && this.watermarkMode) {
    //   this.watermarkMode = false;
    //   this.phiSecurityService.disableWatermark();
    // }

    // NOTE: We do NOT emit isPHIFunc.next(this.phiChecked) here immediately.
    // We wait until verification is complete (if enabling) or emit immediately if disabling.
    if (this.phiChecked && this.searchByKey && this.searchByKey.length > 0) {
      if (this.searchByKey.find((f: any) => f.value === "PH")) {
        if (!this.searchByKey.some((o: any) => o.value === 'PH')) {
          this.searchByKey.push(this.phiSearchInfo);
        }
      }
    } else {
      this.searchByKey = this.searchByKey.filter((o: any) => o.value !== 'PH');
    }

    // only call the openlogindialog when the verification_toggle is true & the toggle is checked
    if (event.verification_toggle && this.phiChecked) {
      if(this.filterService.phiAccessConsentFlag == 'N') {
        this.openLoginDialog(event);
      } else {
        this.phiFromGrid.emit(this.phiChecked);
        this.mixpanelService.track(this.moduleName + ' - '+this.dashboardService.dashboardName+ ' - '+ 'PHI Select - ' + (this.phiChecked ? 'True' : 'False'));
      }
    } else {
      // // Emit PHI state change now (either disabling, or enabling without verification)
      // this.filterService.isPHIFunc.next(this.phiChecked);

      // // If PHI is being enabled and event.iswatermark is true, enable watermark
      // if (this.phiChecked && false) {
      //   this.watermarkMode = true;
      //   this.phiSecurityService.enableWatermark();
      // }

      // // If manually deactivating PHI, stop the timer
      // if (!this.phiChecked) {
      //   this.phiTimerService.stopTimer();
      // }

      this.phiFromGrid.emit(this.phiChecked);
      this.mixpanelService.track(this.moduleName + ' - '+this.dashboardService.dashboardName+ ' - '+ 'PHI Select - ' + (this.phiChecked ? 'True' : 'False'));
    }
  }

  openLoginDialog(event: any): void {
    const dialogRef = this.dialog.open(LoginPopupComponent, {
      width: "500px",
      height: "auto",
      disableClose: false,
      panelClass: "login-dialog-panel",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        // Login was successful, proceed with PHI access
        // this.filterService.isPHIFunc.next(this.phiChecked);
        this.phiFromGrid.emit(this.phiChecked);
        this.mixpanelService.track(this.moduleName + ' - '+this.dashboardService.dashboardName+ ' - '+ 'PHI Select - ' + (this.phiChecked ? 'True' : 'False'));

        // If PHI is being enabled and event.iswatermark is true, enable watermark
        // if (this.phiChecked && event.iswatermark) {
        //   this.watermarkMode = true;
        //   this.phiSecurityService.enableWatermark();
        // }
      } else {
        // Login failed or cancelled, revert the PHI toggle
        this.phiChecked = false;
        this.filterService.phiChecked = false;
        sessionStorage.removeItem('phiLogged')
        this.phiSecurityService.removePHIWarningOverlay();
        this.phiSecurityService.disableRestrictions();

        // Ensure watermark is disabled if it was somehow enabled
        // if (this.watermarkMode) {
        //   this.watermarkMode = false;
        //   this.phiSecurityService.disableWatermark();
        // }

        // Emit PHI state change to disable security restrictions
        // this.filterService.isPHIFunc.next(this.phiChecked);
        // this.mixpanelService.track(this.moduleName + ' - '+this.dashboardService.dashboardName+ ' - '+ 'PHI Select - ' + (this.phiChecked ? 'True' : 'False'));
      }
    });
  }

  /**
   * Will set the analytical mode to true or false if provided an argument
   * but will just toggle the value of useAnalyticalMode if no argument is provided
   */

  public setAnalyticalMode(state?: boolean): void {
    this.pixelMapRef.setAnalyticalMode(state);
  }

  onQuickFilterChanged(event: any) {
    this.typeToSearch.emit(event.target.value)
  }

  serverSideSearchClose(event: any, hdr: any) {
    if (this.serverSideSearchFilterText == "") {
      this.userStateForServerSideSearch = this.selectedSearchByKey + ' ' + this.serverSideSearchFilterText;
      let selectObj = {
        filterValue: "",
        obj: {},
        hdr
      }
      setTimeout(() => {
        this.serverSideSearchEmits.emit(selectObj)
      }, 100);
    }
  }

  serverSideSearch(hdr?: any) {
    if (this.userStateForServerSideSearch == this.selectedSearchByKey + ' ' + this.serverSideSearchFilterText) return;
    this.userStateForServerSideSearch = this.selectedSearchByKey + ' ' + this.serverSideSearchFilterText;

    let data = this.searchByKey.find((f: any) => this.selectedSearchByKey == f.value);
    if (data) {
      let selectObj = {
        hdr,
        filterValue: this.serverSideSearchFilterText,
        obj: {
          [data.param]:
            (data.value == 'PI' || data.value == 'HPI' || data.value == 'SPI' || data.comma)
              ? this.serverSideSearchFilterText
                ? data.value == 'PRN'
                  ? this.serverSideSearchFilterText.split(/[|@#&]+/).join(',') // excludes space
                  : this.serverSideSearchFilterText.split(/[\|\s@#&]+/).join(',') // includes space
                : ''
              : this.serverSideSearchFilterText,
          "search_prm": data.value,
        }
      }
      setTimeout(() => {
        this.serverSideSearchEmits.emit(selectObj)
      }, 100);
    }
  }

  onPageSizeChanged() {
    if (this.paginationPageSize == 0) {
      this.paginationPageSize = 10
    }
    if (this.paginationPageSize > 1000) {
      this.paginationPageSize = 1000
    }
    this.onPageSizeChange.emit(this.paginationPageSize)
  }

  sortByChange(event: any) {
    this.filterService.sortByChanged.next(event)
  }
  triggerSorts(event: any) {
    this.filterService.triggerSort.next(event)
  }
  changeDisplayType(selectedType: any, item?:any) {
    // debugger
    this.selectedType = selectedType
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    this.filterService.setSelectionToggle(widgetKey, selectedType);
    this.filterService.pageChangeDisplays = {selectedType: selectedType, findVar: item?.groupby_page_level};
    this.changeDisplays.emit(selectedType)

    if(item?.groupby_page_level) {
      // Emit as before
      this.filterService.chartshowBy.next({
        widget: this.item['key'],
        value: selectedType,
        item: this.item
      });
    } else if (this.isFlagOn(item?.agg_data_level ?? this.item?.config?.agg_data_level)) {
      // Toggle flagged with agg_data_level (no page-level grouping): switch the
      // nested chart the same way showByChange() does for the Show By dropdown.
      this.filterService.chartshowBy.next({
        widget: this.item['key'],
        value: selectedType,
        item: this.item
      });
    }
  }

  /** Designer flags may be saved as true, "true", "Yes" or a dropdown object like { name: 'Yes' }. */
  private isFlagOn(v: any): boolean {
    const s = String(typeof v === 'object' && v !== null ? (v.value ?? v.name) : v).trim().toLowerCase();
    return s === 'true' || s === 'yes';
  }

  findSelectedTypeCount(selectedType: any, item?:any) {
    const groupKey = item?.groupby_page_level;
    if (groupKey == null) {
      return '';
    }
    const distinctSourceKeys = new Set(
      (this.pageDataService.toggleData || [])
        .filter((row: any) => row?.[groupKey] == selectedType)
        .map((row: any) => row?.source_key)
        .filter((key: any) => key != null)
    );
    return ` (${distinctSourceKeys.size})`;
  }

  increment() {
    if (this.counter >= 9) {
      this.dialogService.openSnackBar("Moving Average Limit ( 2 - 9 )", "OK")
      return
    } else {
      if (this.counter == '') {
        this.counter = 2
        return
      }
      this.counter++;
    }
  }

  decrement() {
    if (this.counter < 3) {
      this.counter = 2
      this.dialogService.openSnackBar("Moving Average Limit ( 2 - 9 )", "OK")
      return
    } else {
      this.counter--;
    }
  }

  numberOnly(event: any): boolean {

    if (!this.clickedevent) {
      this.clickedevent = true;
      setTimeout(() => {
        this.clickedevent = false;
      }, 300);
      const charCode = (event?.which) ? event.which : event.keyCode;
      if (event.code == "NumpadDecimal" || event.code == "Quote" || event.code == "Period") { this.dialogService.openSnackBar("Moving Average Limit ( 2 - 9 )", "OK"); return false }
      if (charCode == 8 || charCode == 46 || charCode == 37 || charCode == 39 || charCode == 38 || charCode == 40) { return true }
      if ((charCode < 113 && charCode > 96) || charCode == 110 || charCode == 39) { this.dialogService.openSnackBar("Moving Average Limit ( 2 - 9 )", "OK"); return false }
      if (charCode > 31 && (charCode < 50 || charCode > 57) && (charCode < 97 || charCode > 105)) {
        this.dialogService.openSnackBar("Moving Average Limit ( 2 - 9 )", "OK")
        return false;
      } else { return true; }
    } else {
      return false
    }
  }

  findFromtheFilter(filterKey: any) {
    return ''
  }

  countSave(ctrl: any) {

    if (this.counter != '') {
      this.selectedCount = this.counter
      this.filterService.movingAverage.next(this.counter);
      document.getElementById("moving_average")?.click()
    } else {
      this.counter = 2
      this.dialogService.openSnackBar("Moving Average Limit ( 2 - 9 )", "OK")
    }
  }

  changeTimeCycleEvent(event: any, selectedType: any) {
    event.preventDefault();
    event.stopPropagation()
    if (this.selectedTypeTimeCyle == selectedType) return
    this.userActivityService.setData({ "selectedType": selectedType })
    this.timeCycleChanges.emit(selectedType);
    // this.filterService.changeTimeCycle.next(selectedType)
  }

  followUP() {
    this.filterService.followUP.next(true);
  }
  exportToPNG() {
    let headerId: any = this.heading.replaceAll(' ', '') == '' ? 'header' : this.sanitizeId(this.heading)
    const element = document.querySelector('#' + headerId);
    if (element) {
      this.SubHeading = element.textContent
    }
    else {
      this.SubHeading = undefined
    }

    this.progress = 0;
    this.exportError = false;
    this.progressLabel = 'Exporting';
    this.exportErrorMessage = API_ERROR_COPY.unknown;
    this.dialogRef = this.dialog.open(this.progressBar, {
      disableClose: true,
      width: '400px',
      height: '200px'
    });

    this.simulateProgress();
    setTimeout(() => {
      // Resolve `config` to a real HTMLElement. Parents pass either a plain
      // DOM node or an Angular ElementRef (e.g. [config]="canvasRef"). If
      // the ElementRef wraps an SVG element, html2canvas works better against
      // its parent container, so prefer the parent when possible.
      const el = this.resolveExportElement(this.config);
      if (!el) {
        clearInterval(this.progressInterval);
        console.error('Export error: config is not a valid DOM element', this.config);
        this.exportError = true;
        return;
      }

      const scrollableElement = document.querySelector('#svg_heatmapContainer') as HTMLElement;
      let originalWidth = el.getBoundingClientRect().width;
      if (scrollableElement) {
        el.style.width = `${scrollableElement.scrollWidth}px`;
      }
      const canvasScale = this.isIPadSafari ? 1 : 2;
      html2canvas(el, { useCORS: true, scale: canvasScale, onclone: normaliseColorsForHtml2canvas }).then(canvas => {
        clearInterval(this.progressInterval);
        this.updateProgress(100);

        const imageData = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = imageData;
        link.download = this.SubHeading ? this.SubHeading.replaceAll(" ", "") + '.png' : this.heading + '.png';
        link.click();

        setTimeout(() => this.dialogRef.close(), 500);
      }).catch(err => {
        clearInterval(this.progressInterval);
        console.error('Export error:', err);
        // Flip the dialog into an error state instead of auto-closing — the
        // template renders the message + a close icon the user can click.
        this.exportError = true;
      }).finally(() => {
        if (scrollableElement) {
          el.style.width = `${originalWidth}px`;
        }
      });
    }, 1000);
  }

  /**
   * Normalises whatever the parent passed as [config] to a real HTMLElement
   * we can hand to html2canvas / read .getBoundingClientRect / set .style on.
   * Accepts: HTMLElement, SVGElement (returns its HTML parent), or ElementRef.
   * Returns null when nothing usable is available.
   */
  private resolveExportElement(cfg: any): HTMLElement | null {
    if (!cfg) return null;
    // Plain DOM HTMLElement
    if (cfg instanceof HTMLElement) return cfg;
    // SVG element — html2canvas wants an HTML container, use its parent.
    if (typeof SVGElement !== 'undefined' && cfg instanceof SVGElement) {
      return (cfg.parentElement as HTMLElement) || null;
    }
    // Angular ElementRef
    const native = cfg.nativeElement;
    if (native instanceof HTMLElement) return native;
    if (typeof SVGElement !== 'undefined' && native instanceof SVGElement) {
      return (native.parentElement as HTMLElement) || null;
    }
    return null;
  }

  /**
   * iPad/iPadOS Safari — iPadOS 13+ reports itself as "Macintosh", so the touch
   * check is what separates a real iPad from a desktop Mac.
   */
  private get isIPadSafari(): boolean {
    return /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
  }

  /**
   * Safari on any platform. Desktop Chrome's UA also carries "Safari", and on
   * iOS every browser is WebKit but reports its own token, so both have to be
   * excluded to leave real Safari behind.
   */
  private get isSafari(): boolean {
    const ua = navigator.userAgent;
    return /safari/i.test(ua) && !/chrome|chromium|crios|fxios|edgios|android/i.test(ua);
  }

  /** PNG rendered ahead of the tap that copies it — see prepareCopyImage(). */
  private pendingCopyBlob: Promise<Blob> | null = null;

  /**
   * Rasterises the chart to a PNG blob. Split out of copyImageToClipboard() so
   * the render can be kicked off before the click that consumes it.
   */
  private renderChartBlob(el: HTMLElement): Promise<Blob> {
    const scrollableElement = document.querySelector('#svg_heatmapContainer') as HTMLElement;
    const originalWidth = el.getBoundingClientRect().width;
    if (scrollableElement) {
      el.style.width = `${scrollableElement.scrollWidth}px`;
    }
    // Same reason exportToPNG() drops to scale 1 on iPad: scale 2 exceeds
    // Safari's canvas memory budget and yields a blank/failed render. Elsewhere copy
    // at the screen's own density (capped at 2) - a pasted image as sharp as the
    // chart on screen, without the fixed 2x that rendered up to 4x the pixels.
    const canvasScale = this.isIPadSafari ? 1 : Math.min(2, Math.max(1, window.devicePixelRatio || 1));
    return html2canvas(el, {
      useCORS: true, scale: canvasScale, logging: false, imageTimeout: 0,
      // html2canvas clones the whole page before drawing one element. Leave the other
      // widgets on the dashboard, and any open overlay, out of that clone - on a full
      // dashboard they were most of the work.
      ignoreElements: (node: Element) =>
        (node.tagName === 'GRIDSTER-ITEM' || node.classList?.contains('cdk-overlay-container')) && !node.contains(el),
      // Material 21 colours (color-mix) made html2canvas throw - see html2canvas-colors.ts.
      onclone: normaliseColorsForHtml2canvas,
    })
      .then(canvas => new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(
          blob => blob ? resolve(blob) : reject(new Error('html2canvas produced an empty blob')),
          'image/png'
        );
      }))
      .finally(() => {
        if (scrollableElement) {
          el.style.width = `${originalWidth}px`;
        }
      });
  }

  /**
   * Starts the PNG render when the export menu opens, so "Copy to Clipboard"
   * usually already has its blob by the time it is tapped.
   *
   * Safari grants clipboard access only while the tap's user activation is
   * live. Handing ClipboardItem a pending promise is the documented way to do
   * async work there, but a cold html2canvas run on iPad takes long enough that
   * WebKit drops the write anyway — which is why copy worked in Chrome (iOS
   * relaxes the gating) and not Safari. Rendering during the menu's open time
   * makes the promise already-resolved at tap, so the write is instantaneous.
   */
  prepareCopyImage(icon: any) {
    // Safari only. Every other browser honours the promise handed to
    // ClipboardItem however long it takes, so there a speculative render just
    // burns CPU and briefly widens the heatmap container renderChartBlob()
    // stretches, for an export the user may not even pick.
    if (!this.isSafari) return;
    const offersCopy = (icon?.event || []).some((e: any) => e.value === 'copy_image' && e.is_true == true);
    if (!offersCopy || this.phiChecked) return;
    const el = this.resolveExportElement(this.config);
    if (!el) return;
    const blob = this.renderChartBlob(el);
    // A pre-warm failure stays silent — it only matters if the user goes on to
    // tap Copy, where copyImageToClipboard() reports it.
    blob.catch(() => { });
    this.pendingCopyBlob = blob;
  }

  copyImageToClipboard() {
    // `config` is not always a plain DOM node — parents bind either the element
    // or an Angular ElementRef (and sometimes an SVG node), so reading
    // .getBoundingClientRect()/.style off it directly throws. Resolve it the
    // same way exportToPNG() does.
    const el = this.resolveExportElement(this.config);
    if (!el) {
      console.error('Copy image error: config is not a valid DOM element', this.config);
      this.dialogService.openSnackBar('No content available to copy', 'OK')
      return
    }
    if (!navigator.clipboard || typeof ClipboardItem === 'undefined') {
      // Also the branch a plain http:// host takes — the Clipboard API is
      // secure-context only, so there is no navigator.clipboard off HTTPS.
      this.dialogService.openSnackBar('Clipboard is not supported in this browser', 'OK')
      return
    }

    // Same progress dialog as Export as Image, held open until the clipboard write
    // settles: the render takes a few seconds on a big chart and nothing else showed
    // that a copy was under way.
    this.progress = 0;
    this.exportError = false;
    this.progressLabel = 'Copying to clipboard';
    this.dialogRef = this.dialog.open(this.progressBar, {
      disableClose: true,
      width: '400px',
      height: '200px'
    });
    this.simulateProgress();

    // Pre-rendered on menu open where possible; cold render otherwise. Cleared
    // on use so a second copy never pastes a stale chart. A cold render waits a
    // frame first so the dialog paints before html2canvas takes the main thread.
    const nextPaint = () => new Promise<void>(resolve => requestAnimationFrame(() => setTimeout(resolve)));
    const blobPromise = this.pendingCopyBlob || nextPaint().then(() => this.renderChartBlob(el));
    this.pendingCopyBlob = null;

    // No await before write() — Safari revokes clipboard access the moment the
    // tap's activation ends, so the ClipboardItem takes the promise itself.
    navigator.clipboard.write([new ClipboardItem({ 'image/png': blobPromise })])
      .then(() => {
        clearInterval(this.progressInterval);
        this.updateProgress(100);
        setTimeout(() => this.dialogRef?.close(), 300);
        this.dialogService.openSnackBar('Image copied to clipboard', 'OK');
      })
      .catch(err => {
        clearInterval(this.progressInterval);
        console.error('Copy image error:', err);
        // Name the DOMException: an iPad has no console, and NotAllowedError
        // (Safari refused the write) is a different bug from a render failure.
        // Shown in the dialog's error state, which the user closes.
        this.exportErrorMessage =
          `Failed to copy image to clipboard (${err?.name || 'error'}). Use "Export as Image" instead.`;
        this.exportError = true;
      });
  }
  /** Closes the export progress dialog (called by the X icon in the error state). */
  closeExportDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.exportError = false;
  }

  simulateProgress() {
    this.progressInterval = setInterval(() => {
      if (this.progress < 95) {
        this.progress += Math.random() * 5;
        this.updateProgress(Math.min(95, this.progress));
      }
    }, 100);
  }

  updateProgress(value: number) {
    this.progress = Math.round(value);
  }
  // API call for excel export
  // 100598 - excel export api key
  excelExportAPI() {
    let obj = {
      "api_key": "100598",
      "report_typ": "D",
      "export_api_key": this.item.config?.list_of_api?.api_key || 100127,
    }
    let query = Object.assign({}, this.filterService.baseQuery, obj)
    let widgetEndpoint = this.item.config['widget_endpoint'];
    this.httpClient.post(`${this.apiService.apiBaseUrl}/${widgetEndpoint ? widgetEndpoint : this.apiService.executionUrl}`, query).subscribe((res: any) => {

      let columnData = (res == null || res == undefined) ? [] : res;
      let colDef: any = []
      columnData.filter((f: any) => f.hide_flg == 'Y').forEach((element: any) => {
        colDef.push({
          "header": element.bus_col_nm,
          "key": element.db_col_name,
          "type": element.data_type,
        })
      })
      if (colDef.length > 0) {
        this.excelService.customExportExcel(this.apiKey == 100126 ? this.NetworkChartData : this.data, this.item.config['report_heading'], colDef)
      } else {
        this.dialogService.openSnackBar("No data found for excel export", "OK")
      }
    }, (err: any) => {
      this.dialogService.openSnackBar(
        friendlyApiErrorMessage(err, "We couldn’t prepare this export. Please try again."),
        "OK"
      )
      console.log(err)
    })
  }

  numbedPipe(value: any) {
    if (value == null || undefined) return
    if (typeof value == 'number') {
      return this.currency.transform(value, '', '', '1.0-2');
    }
    if (value.includes('%')) return value
    if (value.includes(',')) {
      let val = value.replaceAll(/,/g, "");
      return this.currency.transform(val, '', '', '1.0-2');
    }
  }

  getLocation() {
    if (sessionStorage.getItem("payloadData")) {
      let pylodData: any = sessionStorage.getItem("payloadData");
      pylodData = JSON.parse(pylodData);
      // Get the location name from the payloadData
      return pylodData?.sp_location_name ?? null
    }
  }
  getXAxisValue() {
    if (sessionStorage.getItem("payloadData")) {
      let pylodData: any = sessionStorage.getItem("payloadData");
      pylodData = JSON.parse(pylodData);
      // Get the location name from the payloadData
      return pylodData?.x_axis_value ?? null
    }
  }

  findWhichKey(key: any, value: any) {
    if (!this.filterService.previousSingleSelectedItems?.[key]) return '';
    let queryFilter = Object.entries(this.filterService.previousSingleSelectedItems[key]).map(([key, value]) => ({ key, value }));
    let ifQuery: any = queryFilter.find((fnd: any) => fnd.key == value?.valueName)

    return ifQuery.value || '.'
  }
  
  findFlagKey(key: any, value: any) {
    if (!this.filterService.previousSingleSelectedItems?.[key]) return '';
    let queryFilter = Object.entries(this.filterService.previousSingleSelectedItems[key]).map(([key, value]) => ({ key, value }));
    let ifQuery: any = queryFilter.find((fnd: any) => fnd.key == value?.flag_name)

    return ifQuery?.value == 'Y' ? true : false;
  }

  findPrefixDateFormat(data: any) {
    if (!this.filterService.baseQuery?.[data.sp_nm_visibility_key]) return '';
    if (data?.date_format_prefix == 'custom') return moment(this.filterService.baseQuery?.[data.sp_nm_visibility_key], 'YYYY-MM-DD').format(data.custom_date_format_prefix);
    return moment(this.filterService.baseQuery?.[data.sp_nm_visibility_key], 'YYYY-MM-DD').format(data.date_format_prefix) + ', ';
  }

  onRangeBarHover($event:any) {
    this.hoverValueChange.emit($event);
  }

  // Replace placeholders in the template with actual values
  replacePlaceholders(template: string): any {
    if (!template) return '';

    return template.replace(/\{\{(.*?)\}\}/g, (_: string, content: string) => {
      const parts = content.split(',').map(s => s.trim());
      const [dataKey, lookupKey, type, formatRaw, select = 'single']: any = parts;

      let rawValue: any = '';

      if (type === 'date' || type === 'quarter') {
        const baseValue = this.filterService.baseQuery?.[dataKey];
        if (!baseValue) return '';

        let m = moment(baseValue, 'YYYY-MM-DD');

        if (type === 'date') {
          rawValue = formatRaw
            ? m.format(formatRaw.replace(/['"]+/g, ''))
            : m.format('YYYY-MM-DD');
        }

        if (type === 'quarter') {
          // Extract format + offset (ex: (Q-YYYY)-3)
          // debugger
          const match = formatRaw?.match(/^\(?([A-Za-z0-9\- ]+)\)?([+-]\d+)?$/);
          const format = match?.[1] ?? 'Q-YYYY';
          const offset = match?.[2] ? parseInt(match[2], 10) : 0;

          // Apply quarter offset
          if (offset !== 0) m = m.add(offset, 'quarters');

          const q = m.quarter();
          const year = m.year();

          switch (format.toLowerCase()) {
            case 'q':
              rawValue = `Q${q}`;
              break;
            case 'q-yyyy':
              rawValue = `Q${q} ${year}`;
              break;
            case 'yyyy-q':
              rawValue = `${year}-Q${q}`;
              break;
            default:
              rawValue = `Q${q} ${year}`;
          }
        }
      } else if (type === 'string') {
        let items: any
        items = select == 'multi' ? (this.filterService.baseQuery?.[lookupKey]?.split(',').length > 1 ? '' : this.filterService.baseQuery?.[lookupKey]) : this.filterService.previousSingleSelectedItems?.[dataKey];
        if (!items) return '';
        if (select == 'multi') {
          rawValue = this.filterService.baseQuery?.[lookupKey]
        } else {
          const queryFilter = Object.entries(items).map(([k, v]) => ({ key: k, value: v }));
          rawValue = queryFilter.find(f => f.key === lookupKey)?.value ?? '';
        }

        if (formatRaw?.toLowerCase() === 'uppercase') rawValue = rawValue.toUpperCase();
        if (formatRaw?.toLowerCase() === 'lowercase') rawValue = rawValue.toLowerCase();
      }

      return rawValue;
    });
  }

  togglePracticeTypes($event: any) {
    this.togglePracticeType.emit($event); 
  }

  findSuffixDateFormat(data: any) {
    if (!this.filterService.baseQuery?.[data.spb_nm_visibility_key]) return '';
    if (data?.date_format_suffix == 'custom') return moment(this.filterService.baseQuery?.[data.spb_nm_visibility_key], 'YYYY-MM-DD').format(data.custom_date_format_suffix)
    return ' - ' + moment(this.filterService.baseQuery?.[data.spb_nm_visibility_key], 'YYYY-MM-DD').format(data.date_format_suffix);
  }

  numberminMax(event: any) {

    if (this.buffer_range >= 0 && this.buffer_range <= 100) {
      this.buffer_range = this.buffer_range
    } else {
      this.buffer_range = null
      this.buffer_range = 0
      alert('Buffer Range  ( 1 - 100)')

    }
  }

  checkLength2(e: any, input: any) {
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'];

    this.numberminMax(e)
    if (functionalKeys.indexOf(e.key) !== -1) {
      return;
    }

    const keyValue = +e.key;
    if (isNaN(keyValue)) {
      e.preventDefault();
      return;
    }

    const hasSelection = input.selectionStart !== input.selectionEnd && input.selectionStart !== null;
    let newValue;
    if (hasSelection) {
      newValue = this.replaceSelection(input, e.key)
    } else {
      newValue = input.value + keyValue.toString();
    }

    if (+newValue > 100 || newValue.length > 3) {
      alert('Buffer Range  ( 1 - 100)')
      e.preventDefault();
    }
  }

  replaceSelection(input: any, key: any) {
    const inputValue = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd || input.selectionStart;
    return inputValue.substring(0, start) + key + inputValue.substring(end + 1);
  }

  restictnumberneg(e: any, input: any) {
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'];

    if (functionalKeys.indexOf(e.key) !== -1) {
      return;
    }

    const keyValue = +e.key;
    if (isNaN(keyValue)) {
      e.preventDefault();
      return;
    }

    const hasSelection = input.selectionStart !== input.selectionEnd && input.selectionStart !== null;
    let newValue;
    if (hasSelection) {
      newValue = this.replaceSelection(input, e.key)
    } else {
      newValue = input.value + keyValue.toString();
    }

    if (newValue.length > 120) {
      e.preventDefault();
    }
  }

  getPeriodtext() {
    switch (this.filterService.report_type) {
      case 'D': return "Days"
      case 'W': return "Weeks"
      case 'M': return "Months"
      case 'Q': return "Quarters"
      case 'Y': return "Years"
    }
  }

  tooltipForShowBy(data: any, value: any): string {
    let label: string = data.find((fnd: any) => fnd.value == value).title
    return label
  }
  
  tooltipForMapShowBy(data: any, value: any): string {
    let label: string = data.find((fnd: any) => fnd.id == value)?.label || data[0]?.label;
    return label
  }

  openPreferencesScreen() {
    this.preferenceEmitter.emit(true);
  }

  prefrecancel() {
    const key = this.widgetUniqKey;
    const backup = localStorage.getItem("pref_backup_" + key);

    if (backup) {
      this.preference = JSON.parse(backup);
      this.preferenceEmitter.emit(this.preference);
    }

    // Close popover
    this.ispreferencesOpen = false;

    // Clear backup
    localStorage.removeItem("pref_backup_" + key);
    this.overlayRef?.dispose();
    this.overlayRef = null!;
  }

  applyChartPreferences(event: any) {
    this.preference = event
    //    const key = this.widgetUniqKey;
    //   if (!localStorage.getItem("pref_backup_" + key)) {
    //   localStorage.setItem("pref_backup_" + key, JSON.stringify(this.preference));
    // }
  }
  applyPreferences(event: any) {
    const obj = {
      dashboard_key: this.dashboardKey,
      page_name: this.item.config["report_heading"],
      page_key: this.pageKey,
      widget_uinique_key: this.widgetUniqKey,
      employee_key: this.filterService.baseQuery?.employee_key || 0,
      preference_value: JSON.stringify(this.preference)
    };

    console.log('Inserting Preference:', obj);

    this.dataService.insertPreference(obj).subscribe({
      next: (res: any) => {
        this.preferenceEmitter.emit(this.preference);
        this.ispreferencesOpen = false;
        const key = this.widgetUniqKey;
        localStorage.setItem("pref_backup_" + key, JSON.stringify(this.preference));
        this.dialogService.SnackBar('Preferences saved successfully', 'OK');
        this.overlayRef?.dispose();
        this.overlayRef = null!;
      },
      error: (err: any) => {
        this.dialogService.SnackBar('Error saving preferences', 'OK');
        //  this.overlayRef?.dispose();
        //  this.overlayRef = null!;
      }
    });
    // this.isPopoverOpen = false;

  }

  previewPreferences(event: any) {

    this.preferenceEmitter.emit(this.preference);
  }
  buildPreferenceModelByKey(config: any, widgetKey: string | number): any {
    const widgetConfig = config?.[widgetKey];
    if (!Array.isArray(widgetConfig)) {
      return {};
    }

    const model: any = {};

    widgetConfig.forEach((section: any) => {
      if (!section?.key || !Array.isArray(section.fields)) {
        return;
      }

      model[section.key] = {};

      section.fields.forEach((field: any) => {
        if (!field?.key) {
          return;
        }

        model[section.key][field.key] =
          field.defaultValue !== undefined ? field.defaultValue : null;
      });
    });

    return model;
  }
  resetPreferences(event: any) {
    const allConfigs = (CHART_PREFS as any).default;
    this.preference = this.buildPreferenceModelByKey(allConfigs, this.item.key);

    const obj = {
      dashboard_key: this.dashboardKey,
      page_name: this.item.config["report_heading"],
      page_key: this.pageKey,
      widget_uinique_key: this.widgetUniqKey,
      employee_key: this.filterService.baseQuery?.employee_key || 0,
      preference_value: JSON.stringify(this.preference)
    };

    this.dataService.insertPreference(obj).subscribe(() => {
      this.preferenceEmitter.emit(this.preference);
      const key = this.widgetUniqKey;
      localStorage.setItem("pref_backup_" + key, JSON.stringify(this.preference));
      this.ispreferencesOpen = false;
      // this.prefFormComponent.onCancel();
      this.dialogService.SnackBar('Preferences reset to default', 'OK');
      this.overlayRef?.dispose();
      this.overlayRef = null!;
    });
  }

  ngOnDestroy(): void {
    // Clean up PHI timer subscription
    if (this.phiTimerSubscription) {
      this.phiTimerSubscription.unsubscribe();
      this.phiTimerSubscription = null;
    }

    // Clean up progress interval
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }

    this.filterService.showByHeader = "false";
    this.reqSubcription.forEach((res) => res.unsubscribe());
    this.resizeObserver?.disconnect();
    this.closePopup();
  }

  closePopup() {
    this.overlayRef?.dispose();
    this.overlayRef = null;
  }

  openPreferences(event: MouseEvent) {
    if (this.overlayRef) {
      this.closePreferences();
      return;
    }

    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo({
        x: event.clientX,
        y: event.clientY
      })
      .withFlexibleDimensions(false)
      .withPush(true)
      .withPositions([
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        },
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom'
        }
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      panelClass: 'settings-overlay-panel'
    });

    this.overlayRef.attach(
      new TemplatePortal(this.preferenceTemplate, this.vcr)
    );

    // this.overlayRef.backdropClick().subscribe(() => this.closePreferences());
  }

  closePreferences() {
    this.overlayRef?.dispose();
    this.overlayRef = null!;
    this.prefrecancel()
  }

}
